<template>
  <div>

    <!-- 最上面蓝色（渐变色）背景的盒子 -->
    <div
      style="width: 100%; height: 100%; padding-top: 50px; padding-bottom: 68px"
      class="container"
    >

      <!-- 最上面的header -->
      <div
        style="
          width: 1170px;
          flex-shrink: 0;
          border-radius: 10px;
          background: #fff;
          margin: 0px auto 0px;
          position: relative;
        "
        ref='header'
      >
        <!-- 第一层 -->
        <div
          style="
            width: 1170px;
            height: 100px;
            border-radius: 10px;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            z-index: 20;
          "
          :style="{ 'border-radius': isRotated ? '10px 10px 0px 0px' : '10px' }"
          ref="firstLayer"
        >
          <img
            src="../assets/imgs/homeNew/cartsee-logo.svg"
            alt=""
            style="width: 126px; height: 28.53px; margin-left: 27px"
          />
          <div style="width: 408px; height: 24px; display: flex; align-items: center">
            <div
              style="
                font-family: PingFang SC;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: 14px;
                margin-left: 5px;
                cursor: pointer;
              "
              @click="
                goRouter('Home', 'home', '')
                isRotated = false;
              "
              :style="{ color: headerCheck === 'home' ? '#333AF4' : '#828297' }"
            >
              主页
            </div>
            <div style="display: flex; align-items: center; cursor: pointer" @click="productClick">
              <div
                style="
                  color: #333af4;
                  font-family: PingFang SC;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: 14px;
                  margin-left: 25px;
                "
                :style="{
                  color: headerCheck === 'product' ? '#333AF4' : '#828297',
                }"
              >
                产品与服务
              </div>
              <img
                src="../assets/imgs/homeNew/Vector.svg"
                alt=""
                style="width: 9px; height: 4px; margin-left: 8px"
                :class="{ rotated: isRotated }"
              />
            </div>

            <div
              style="
                color: #828297;
                font-family: PingFang SC;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: 14px;
                margin-left: 25px;
                cursor: pointer;
              "
              @click="scrollToCustomerCase"
              :style="{ color: headerCheck === 'case' ? '#333AF4' : '#828297' }"
              ref="customerCase"
            >
              客户案例
            </div>
            <div
              style="
                color: #828297;
                font-family: PingFang SC;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: 14px;
                margin-left: 25px;
                cursor: pointer;
              "
              @click="contactUs"
              :style="{
                color: headerCheck === 'contact' ? '#333AF4' : '#828297',
              }"
            >
              联系我们
            </div>
          </div>
          <div style="display: flex; align-items: center">
            <div
              style="
                color: #000;
                text-align: right;
                font-family: PingFang SC;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: 14px;
                letter-spacing: 1.4px;
                margin-right: 25px;
                cursor: pointer;
              "
              @click="login"
            >
              登录
            </div>
            <div
              style="
                display: flex;
                height: 54px;
                padding: 0px 29px 0px 30px;
                justify-content: center;
                align-items: center;
                flex-shrink: 0;
                border-radius: 6px;
                background-color: #060640;
                color: #fff;
                text-align: center;
                font-family: PingFang SC;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: 15px;
                letter-spacing: 1.4px;
                margin-right: 24px;
                cursor: pointer;
              "
              @click="login"
            >
              免费试用
            </div>
          </div>
        </div>

        <transition name="el-fade-in">
                  <!-- 第二层 -->
        <div
          style="
            height: 180px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            border-radius: 0px 0px 10px 10px;
            background: #fff;
      box-shadow: 0px 14px 16.5px -6px rgba(0, 0, 0, 0.1), 0px 2px 5.7px 0px rgba(0, 0, 0, 0.04);
            border-top: 1px solid #f3f3f3;
            padding: 0px 60px;
            position: absolute;
            top: 100px;
            left: 0px;
            right: 0px;
            z-index: 20;
          "
          v-if="isRotated"
          ref="secondLayer"
        >
          <div
            style="width: 250px; height: 91px; padding: 16px; display: flex; cursor: pointer"
            @click="isRotated=false;goRouter('Campaign', 'product', 'campagin')"
          >
            <img
              src="../assets/imgs/homeNew/camp-line.svg"
              alt=""
              style="width: 16px; height: 16px"
            />
            <div style="margin-left: 8px">
              <div
                style="
                  color: #1e2124;
                  font-family: PingFang SC;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 600;
                  line-height: 110.5%;
                "
              >
                营销活动 · Campaign
              </div>
              <div
                style="
                  color: #959aa0;
                  font-family: PingFang SC;
                  font-size: 11px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 152%;
                  margin-top: 10px;
                "
              >
                Campaigns 是邮件和短信的主动营销功能，需要一些介绍文案
              </div>
            </div>
          </div>

          <div
            style="width: 250px; height: 91px; padding: 16px; display: flex; cursor: pointer"
            @click="goRouter('Flow', 'product', 'flow');isRotated = false"
          >
            <img
              src="../assets/imgs/homeNew/flow-line.svg"
              alt=""
              style="width: 16px; height: 16px"
            />
            <div style="margin-left: 8px">
              <div
                style="
                  color: #1e2124;
                  font-family: PingFang SC;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 600;
                  line-height: 110.5%;
                "
              >
                营销流程 · Flow
              </div>
              <div
                style="
                  color: #959aa0;
                  font-family: PingFang SC;
                  font-size: 11px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 152%;
                  margin-top: 10px;
                "
              >
                采集用户信息的主要方式，一些介绍文案，需要一些介绍文案
              </div>
            </div>
          </div>

          <div
            style="width: 250px; height: 91px; padding: 16px; display: flex; cursor: pointer"
            @click="goRouter('Tanchuan', 'product', 'tanchuan');isRotated = false"
          >
            <img
              src="../assets/imgs/homeNew/tanchuan-line.svg"
              alt=""
              style="width: 16px; height: 16px"
            />
            <div style="margin-left: 8px">
              <div
                style="
                  color: #1e2124;
                  font-family: PingFang SC;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 600;
                  line-height: 110.5%;
                "
              >
                收集弹窗 · Sign-up forms
              </div>
              <div
                style="
                  color: #959aa0;
                  font-family: PingFang SC;
                  font-size: 11px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 152%;
                  margin-top: 10px;
                "
              >
                采集用户信息的主要方式，一些介绍文案，需要一些介绍文案
              </div>
            </div>
          </div>

          <div
            style="width: 250px; height: 91px; padding: 16px; display: flex; cursor: pointer"
            @click="goRouter('User', 'product', 'user');isRotated = false"
          >
            <img src="../assets/imgs/homeNew/user1.svg" alt="" style="width: 16px; height: 16px" />
            <div style="margin-left: 8px">
              <div
                style="
                  color: #1e2124;
                  font-family: PingFang SC;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 600;
                  line-height: 110.5%;
                "
              >
                用户细分 · User group
              </div>
              <div
                style="
                  color: #959aa0;
                  font-family: PingFang SC;
                  font-size: 11px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 152%;
                  margin-top: 10px;
                "
              >
                根据不同用户行为将用户分组，以便采取针对性的营销策略。
              </div>
            </div>
          </div>
        </div>
      </transition>

      </div>

      <!-- 首页的大header  banner -->
      <div
        v-if="headerCheck === 'home' || bannerCheck === ''"
        style="display: flex; width: 1170px; margin: 0px auto 0px; position: relative"
      >

        <!-- 左侧 -->
        <div style="width: 474px; margin-top: 111px">
          <div
            style="
              color: #060640;
              font-family: Alibaba PuHuiTi 2;
              font-size: 42px;
              font-style: normal;
              font-weight: 800;
              line-height: 59.5px;
              width: 474px;
            "
          >
            更适合中国跨境电商卖家
            <br />
            的营销自动化引擎！✌️
          </div>
          <div
            style="
              color: #9090a7;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 35px;
              width: 474px;
            "
          >
            通过 Cartsee 自动触发符合电商消费场景的邮件、短信，帮助卖家带来高质量的营收增长和复购率提升。通过产品化的精细化用户运营策略、适用于跨境电商的AIGC大模型，将潜在客户、流失用户转化为网站活跃用户，将首单用户转化为持续复购的忠诚用户。Cartsee 为跨境电商卖家带来高含金量的业务增长。
          </div>
          <div style="display: flex; height: 60px; align-items: center; margin-top: 54px">
            <div
              style="
                display: flex;
                height: 60px;
                padding: 0px 41px 0px 40px;
                justify-content: center;
                align-items: center;
                flex-shrink: 0;
                border-radius: 6px;
                background: #060640;
                color: #fff;
                text-align: center;
                font-family: PingFang SC;
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 15px;
                letter-spacing: 1.6px;
                width: 152px;
                cursor: pointer;
              "
              @click="login"
            >
              免费试用
            </div>
            <!-- <img
              src="../assets/imgs/homeNew/video.svg"
              alt=""
              style="width: 102px; height: 102px; margin-left: 24px;cursor: pointer;"
              @click="video"
            /> -->
          </div>
          <div
            style="
              width: 418px;
              height: 136px;
              flex-shrink: 0;
              border-radius: 14px;
              background: rgba(255, 255, 255, 0.7);
              backdrop-filter: blur(5px);
              margin-top: 70px;
              padding: 23px 21px 19px 21px;
            "
          >
            <div style="display: flex; align-items: center; justify-content: space-between">
              <img
                src="../assets/imgs/homeNew/straight-quotes.svg"
                alt=""
                style="width: 32px; height: 32px"
              />
              <div style="display: flex; align-items: center">
                <img
                  src="../assets/imgs/homeNew/star.svg"
                  alt=""
                  style="
                    display: flex;
                    width: 20px;
                    height: 20px;
                    justify-content: center;
                    align-items: center;
                    flex-shrink: 0;
                  "
                />
                <span
                  style="
                    color: #060640;
                    font-family: Airbnb Cereal App;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 15px;
                    margin-left: 5px;
                  "
                  >4.9</span
                >
              </div>
            </div>
            <div
              style="
                color: #9090a7;
                font-family: PingFang SC;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 26px;
                margin-top: 10px;
              "
            >
              这个方式给我们带来了大量的复购，一个月后，复购订单的占比高达30% -
              <span
                style="
                  color: #9090a7;
                  font-family: PingFang SC;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 600;
                  line-height: 26px;
                "
                >独立站卖家</span
              >
            </div>
          </div>
        </div>
        <!-- 右侧的图 -->
        <div
          style="
            margin-top: 20px;
            margin-left: 28px;
            width: 793px;
            height: 678px;
            position: absolute;
            left: 474px;
            /* z-index: 2; */
          "
        >
          <img src="../assets/imgs/homeNew/banner.gif" alt="" style="width: 100%; height: 100%" />
        </div>
        <transition name="dropdown">
                                                <!-- 蒙层 -->
      <div
      v-if="isRotated"
      style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
        z-index: 2000; /* 保证在第二层之上 */
      "
    ></div>

        </transition>

      </div>

      <transition name="fade2">
        <div
        v-if="bannerCheck === 'campagin'"
        style="display: flex; width: 1170px; margin: 0px auto 0px"
      >
                                             <!-- 蒙层 -->
  <div
      v-if="isRotated"
      style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
        z-index: 2000; /* 保证在第二层之上 */
      "
    ></div>
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 100%;
            align-items: center;
            margin-top: 102px;
            padding-bottom: 48px;
          "
        >
          <div style="display: flex; align-items: center">
            <img
              src="../assets/imgs/homeNew/camp-line.svg"
              alt=""
              style="width: 16px; height: 16px; margin-right: 9px"
            />
            <div
              style="
                color: #4d5359;
                font-family: PingFang SC;
                font-size: 18px;
                font-style: normal;
                font-weight: 500;
                line-height: 110.5%;
              "
            >
              营销活动 · Campaign
            </div>
          </div>
          <div style="margin-top: 21px; width: 542px; height: 66px; display: flex">
            <div
              style="
                color: #333af4;
                font-family: Alibaba PuHuiTi 2;
                font-size: 60px;
                font-style: normal;
                font-weight: 900;
                line-height: 110.5%;
              "
            >
              高效简单
            </div>
            <div
              style="
                color: #1e2124;
                font-family: Alibaba PuHuiTi 2;
                font-size: 60px;
                font-style: normal;
                font-weight: 900;
                line-height: 110.5%;
              "
            >
              的营销活动
            </div>
          </div>
          <div
            style="
              width: 847px;
              color: #6b6d6e;
              text-align: center;
              font-family: PingFang SC;
              font-size: 20px;
              font-style: normal;
              font-weight: 400;
              line-height: 180%;
              margin-top: 26px;
            "
          >
            Campaign
            是邮件和短信的主动营销功能，最终会落在发好每一封邮件的能力上，我们通过一系列产品和技术的策略，优化邮件发送的各项指标，让每一封邮件的价值提升
          </div>

          <div
            style="
              display: flex;
              width: 224px;
              height: 60px;
              justify-content: center;
              align-items: center;
              border-radius: 6px;
              background: #060640;
              color: #fff;
              text-align: center;
              font-family: PingFang SC;
              font-size: 14px;
              font-style: normal;
              font-weight: 500;
              line-height: 15px;
              letter-spacing: 1.4px;
              margin-top: 34px;
              cursor: pointer;
            "
            @click="login"
          >
            免费试用
          </div>
        </div>
      </div>
      </transition>
      <!-- 产品服务---- >营销活动 banner -->

      <transition name="fade2">     <!-- 产品服务----》营销流程flow的banner -->
      <div v-if="bannerCheck === 'flow'" style="display: flex; width: 1170px; margin: 0px auto 0px">
                                                    <!-- 蒙层 -->
                                                    <div
      v-if="isRotated"
      style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
        z-index: 2000; /* 保证在第二层之上 */
      "
    ></div>
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 100%;
            align-items: center;
            margin-top: 102px;
            padding-bottom: 48px;
          "
        >
          <div style="display: flex; align-items: center">
            <img
              src="../assets/imgs/homeNew/flow-line.svg"
              alt=""
              style="width: 18px; height: 18px; margin-right: 9px"
            />
            <div
              style="
                color: #4d5359;
                font-family: PingFang SC;
                font-size: 18px;
                font-style: normal;
                font-weight: 500;
                line-height: 110.5%;
              "
            >
              营销流程 · Flow
            </div>
          </div>
          <div style="margin-top: 21px; width: 600px; height: 66px; display: flex">
            <div
              style="
                color: #333af4;
                font-family: Alibaba PuHuiTi 2;
                font-size: 60px;
                font-style: normal;
                font-weight: 900;
                line-height: 110.5%;
              "
            >
              千人千面
            </div>
            <div
              style="
                color: #1e2124;
                font-family: Alibaba PuHuiTi 2;
                font-size: 60px;
                font-style: normal;
                font-weight: 900;
                line-height: 110.5%;
              "
            >
              的自动化运营
            </div>
          </div>
          <div
            style="
              width: 643px;
              color: #6b6d6e;
              text-align: center;
              font-family: PingFang SC;
              font-size: 20px;
              font-style: normal;
              font-weight: 400;
              line-height: 180%;
              margin-top: 26px;
            "
          >
            是根据用户场景自动触发的邮件体系，它可以实现千人千面的个性化营销
            主要用来做复购及用户忠诚度
          </div>

          <div
            style="
              display: flex;
              width: 224px;
              height: 60px;
              justify-content: center;
              align-items: center;
              border-radius: 6px;
              background: #060640;
              color: #fff;
              text-align: center;
              font-family: PingFang SC;
              font-size: 14px;
              font-style: normal;
              font-weight: 500;
              line-height: 15px;
              letter-spacing: 1.4px;
              margin-top: 34px;
              cursor: pointer;
            "
            @click="login"
          >
            免费试用
          </div>
        </div>
      </div></transition>

      <transition name="fade2">
              <!-- 产品服务 ----》用户细分的banner -->
      <div v-if="bannerCheck === 'user'" style="display: flex; width: 1170px; margin: 0px auto 0px">
                                                    <!-- 蒙层 -->
                                                    <div
      v-if="isRotated"
      style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
        z-index: 2000; /* 保证在第二层之上 */
      "
    ></div>
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 100%;
            align-items: center;
            margin-top: 102px;
            padding-bottom: 48px;
          "
        >
          <div style="display: flex; align-items: center">
            <img
              src="../assets/imgs/homeNew/user1.svg"
              alt=""
              style="width: 18px; height: 18px; margin-right: 9px"
            />
            <div
              style="
                color: #4d5359;
                font-family: PingFang SC;
                font-size: 18px;
                font-style: normal;
                font-weight: 500;
                line-height: 110.5%;
              "
            >
              用户细分 · User group
            </div>
          </div>
          <div style="margin-top: 21px; width: 600px; height: 66px; display: flex">
            <div
              style="
                color: #1e2124;
                font-family: Alibaba PuHuiTi 2;
                font-size: 60px;
                font-style: normal;
                font-weight: 900;
                line-height: 110.5%;
              "
            >
              动态用户
            </div>
            <div
              style="
                color: #333af4;
                font-family: Alibaba PuHuiTi 2;
                font-size: 60px;
                font-style: normal;
                font-weight: 900;
                line-height: 110.5%;
              "
            >
              智能细分
            </div>
          </div>
          <div
            style="
              width: 847px;
              color: #6b6d6e;
              text-align: center;
              font-family: PingFang SC;
              font-size: 20px;
              font-style: normal;
              font-weight: 400;
              line-height: 180%;
              margin-top: 26px;
            "
          >
            用户群是卖家推送邮件和短信前，系统自动划分出的不同人群，帮助独立站做用户订阅增长
            以便于更多的流量能够留存下来
          </div>

          <div
            style="
              display: flex;
              width: 224px;
              height: 60px;
              justify-content: center;
              align-items: center;
              border-radius: 6px;
              background: #060640;
              color: #fff;
              text-align: center;
              font-family: PingFang SC;
              font-size: 14px;
              font-style: normal;
              font-weight: 500;
              line-height: 15px;
              letter-spacing: 1.4px;
              margin-top: 34px;
              cursor: pointer;
            "
            @click="login"
          >
            免费试用
          </div>
        </div>
      </div>
      </transition>

      <transition name="fade2">
             <!-- 产品服务----》订阅弹窗 -->
      <div
        v-if="bannerCheck === 'tanchuan'"
        style="display: flex; width: 1170px; margin: 0px auto 0px"
      >
                                                  <!-- 蒙层 -->
                                                  <div
      v-if="isRotated"
      style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
        z-index: 2000; /* 保证在第二层之上 */
      "
    ></div>
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 100%;
            align-items: center;
            margin-top: 102px;
            padding-bottom: 48px;
          "
        >
          <div style="display: flex; align-items: center">
            <img
              src="../assets/imgs/homeNew/tanchuan-line.svg"
              alt=""
              style="width: 18px; height: 18px; margin-right: 9px"
            />
            <div
              style="
                color: #4d5359;
                font-family: PingFang SC;
                font-size: 18px;
                font-style: normal;
                font-weight: 500;
                line-height: 110.5%;
              "
            >
              收集弹窗 · Subscribe pop-up
            </div>
          </div>
          <div style="margin-top: 21px; width: 600px; height: 66px; display: flex">
            <div
              style="
                color: #333af4;
                font-family: Alibaba PuHuiTi 2;
                font-size: 60px;
                font-style: normal;
                font-weight: 900;
                line-height: 110.5%;
              "
            >
              不漏掉任何访客
            </div>
            <div
              style="
                color: #1e2124;
                font-family: Alibaba PuHuiTi 2;
                font-size: 60px;
                font-style: normal;
                font-weight: 900;
                line-height: 110.5%;
              "
            >
              的弹窗
            </div>
          </div>
          <div
            style="
              width: 847px;
              color: #6b6d6e;
              text-align: center;
              font-family: PingFang SC;
              font-size: 20px;
              font-style: normal;
              font-weight: 400;
              line-height: 180%;
              margin-top: 26px;
            "
          >
            弹窗是用户在网站进行一系列的操作行为下，卖家为收集用户信息时所用到的工具，支持大转盘、页面弹窗、用户将要退出网址时候的挽留、以及优惠券的提醒等多种弹出方式和多种样式的用户收集工具
          </div>

          <div
            style="
              display: flex;
              width: 224px;
              height: 60px;
              justify-content: center;
              align-items: center;
              border-radius: 6px;
              background: #060640;
              color: #fff;
              text-align: center;
              font-family: PingFang SC;
              font-size: 14px;
              font-style: normal;
              font-weight: 500;
              line-height: 15px;
              letter-spacing: 1.4px;
              margin-top: 34px;
              cursor: pointer;
            "
            @click="login"
          >
            免费试用
          </div>
        </div>
      </div>
      </transition>

    </div>

    <!-- 首页的 content 内部部分 -->
    <div
      style="width: 100%; height: 100%; background-color: #fff; padding-top: 94px"
      v-if="headerCheck === 'home' || bannerCheck === ''"
    >
      <div style="width: 1170px; margin: 0px auto 0px">
        <div style="display: flex; flex-direction: column; align-items: center">
          <img src="../assets/imgs/homeNew/Ellipse.svg" alt="" style="width: 46px; height: 23px" />
          <div
            style="
              color: #060640;
              text-align: center;
              font-family: PingFang SC;
              font-size: 44px;
              font-style: normal;
              font-weight: 500;
              line-height: 55px;
              margin-top: 2px;
            "
          >
            一站式自动化运营方案
          </div>
          <div
            style="
              color: #6a6a7e;
              text-align: center;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 12px;
              width: 677px;
            "
          >
            为卖家实现单用户价值（revenue-per-recipient）最大化，为跨境电商各个细分品类的卖家提供包含智能用户分层、高转化率商品匹配、高点击率邮件模板、高送达率通道等一站式自动化运营方案。
          </div>
        </div>

        <!-- 切换部分 -->

        <div
          style="
            display: flex;
            width: 1170px;
            justify-content: space-between;
            margin-top: 60px;
            padding: 0px 35px;
            border-bottom: 1px solid #ccc;
          "
        >
          <div
            style="width: 200px; cursor: pointer"
            :class="{ selected: selectedOption === '1' }"
            @click="selectOption('1')"
          >
            <div
              style="
                color: #292930;
                font-family: Noto Sans;
                font-size: 10px;
                font-style: normal;
                font-weight: 500;
                line-height: 156.5%;
                letter-spacing: 1.515px;
                text-transform: uppercase;
                width: 200px;
              "
            >
              // 01 . user segmentation
            </div>
            <div
              style="
                font-family: PingFang SC;
                font-size: 28px;
                font-style: normal;
                font-weight: 600;
                line-height: 110.5%;
                margin-top: 10px;
              "
              :style="{ color: selectedOption === '1' ? '#333af4' : '#292930' }"
            >
              智能用户分层
            </div>
            <transition name="fade">
              <div
              style="width: 168px; margin-top: 24px;"
              :style="{ transform: `translateX(${underlinePosition}px)` }"
              class="underline"
            >
              <div
                style="
                  width: 74px;
                  height: 4px;
                  flex-shrink: 0;
                  background: #333af4;
                  margin: 0 auto;
                "
              ></div>
            </div>

            </transition>

          </div>

          <div
            style="width: 200px; cursor: pointer"
            :class="{ selected: selectedOption === '2' }"
            @click="selectOption('2')"
          >
            <div
              style="
                color: #292930;
                font-family: Noto Sans;
                font-size: 10px;
                font-style: normal;
                font-weight: 500;
                line-height: 156.5%;
                letter-spacing: 1.515px;
                text-transform: uppercase;
                width: 200px;
              "
            >
              // 02 . YOU MAY LIKE
            </div>
            <div
              style="
                font-family: PingFang SC;
                font-size: 28px;
                font-style: normal;
                font-weight: 600;
                line-height: 110.5%;
                margin-top: 10px;
              "
              :style="{ color: selectedOption === '2' ? '#333af4' : '#292930' }"
            >
              商品精准推荐
            </div>
            <!-- <transition name="fade">
              <div style="width: 168px; margin-top: 24px;"  :style="{ transform: `translateX(${underlinePosition}px)` }">
              <div
                style="
                  width: 74px;
                  height: 4px;
                  flex-shrink: 0;
                  background: #333af4;
                  margin: 0 auto;
                "
              ></div>
            </div>
            </transition> -->


          </div>

          <div
            style="width: 200px; cursor: pointer"
            :class="{ selected: selectedOption === '3' }"
            @click="selectOption('3')"
          >
            <div
              style="
                color: #292930;
                font-family: Noto Sans;
                font-size: 10px;
                font-style: normal;
                font-weight: 500;
                line-height: 156.5%;
                letter-spacing: 1.515px;
                text-transform: uppercase;
                width: 200px;
              "
            >
              // 03 . Email Composition
            </div>
            <div
              style="
                font-family: PingFang SC;
                font-size: 28px;
                font-style: normal;
                font-weight: 600;
                line-height: 110.5%;
                margin-top: 10px;
              "
              :style="{ color: selectedOption === '3' ? '#333af4' : '#292930' }"
            >
              高效邮件创作
            </div>
            <!-- <transition name="fade">
              <div style="width: 168px; margin-top: 24px" v-if="selectedOption === '3'">
              <div
                style="
                  width: 74px;
                  height: 4px;
                  flex-shrink: 0;
                  background: #333af4;
                  margin: 0 auto;
                "
              ></div>
            </div>
            </transition> -->

          </div>

          <div
            style="width: 200px; cursor: pointer"
            :class="{ selected: selectedOption === '4' }"
            @click="selectOption('4')"
          >
            <div
              style="
                color: #292930;
                font-family: Noto Sans;
                font-size: 10px;
                font-style: normal;
                font-weight: 500;
                line-height: 156.5%;
                letter-spacing: 1.515px;
                text-transform: uppercase;
                width: 200px;
              "
            >
              // 04 . Excellent Channels
            </div>
            <div
              style="
                font-family: PingFang SC;
                font-size: 28px;
                font-style: normal;
                font-weight: 600;
                line-height: 110.5%;
                margin-top: 10px;
              "
              :style="{ color: selectedOption === '4' ? '#333af4' : '#292930' }"
            >
              卓越通道效果
            </div>
            <!-- <transition name="fade">
              <div style="width: 168px; margin-top: 24px" v-if="selectedOption === '4'">
              <div
                style="
                  width: 74px;
                  height: 4px;
                  flex-shrink: 0;
                  background: #333af4;
                  margin: 0 auto;
                "
              ></div>
            </div>
            </transition> -->

          </div>
        </div>

        <div v-if="headerCheck === 'home' || bannerCheck === ''">
          <transition name="fade1">
          <!-- 智能用户分屏tab下的内容 -->
          <div style="display: flex; padding-bottom: 80px" v-if="selectedOption === '1'">
            <div style="margin-top: 80px">
              <div style="width: 581px">
                <div style="display: flex">
                  <div>
                    <img
                      src="../assets/imgs/homeNew/ai.svg"
                      alt=""
                      style="width: 75px; height: 75px"
                    />
                  </div>
                  <div>
                    <div
                      style="
                        color: #2d2d3e;
                        font-family: PingFang SC;
                        font-size: 21px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 110.5%;
                        margin-left: 16px;
                      "
                    >
                      AI 用户分层
                    </div>
                    <div
                      style="height: 0.877px; background: #e5e5e5; width: 100%; margin-top: 8px"
                    ></div>
                    <div
                      style="
                        color: #6a6a7e;
                        font-family: PingFang SC;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 160%;
                        margin-left: 16px;
                        margin-top: 22px;
                      "
                    >
                      经过海量电商行业数据训练的用户画像模型，为卖家提供精准的用户分层数据，包含新用户、活跃用户、高潜力用户、潜在可转化用户和需召回用户等类型。帮助卖家通过精细化运营策略实现实现营收效果最大化。
                    </div>
                  </div>
                </div>
              </div>

              <div style="width: 581px; margin-top: 40px">
                <div style="display: flex">
                  <div>
                    <img
                      src="../assets/imgs/homeNew/user-circle.svg"
                      alt=""
                      style="width: 75px; height: 75px"
                    />
                  </div>
                  <div>
                    <div
                      style="
                        color: #2d2d3e;
                        font-family: PingFang SC;
                        font-size: 21px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 110.5%;
                        margin-left: 16px;
                      "
                    >
                      用户画像分类
                    </div>
                    <div
                      style="height: 0.877px; background: #e5e5e5; width: 100%; margin-top: 8px"
                    ></div>
                    <div
                      style="
                        color: #6a6a7e;
                        font-family: PingFang SC;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 160%;
                        margin-left: 16px;
                        margin-top: 22px;
                      "
                    >
                      提供用户基础信息、消费行为、兴趣爱好和网站行为等数十种用户数据，以及便捷的用户群创建和管理平台，帮助卖家快速洞察网站的用户画像，发现增长点。
                    </div>
                  </div>
                </div>
              </div>

              <div style="width: 581px; margin-top: 40px">
                <div style="display: flex">
                  <div>
                    <img
                      src="../assets/imgs/homeNew/renhuopipei.svg"
                      alt=""
                      style="width: 75px; height: 75px"
                    />
                  </div>
                  <div>
                    <div
                      style="
                        color: #2d2d3e;
                        font-family: PingFang SC;
                        font-size: 21px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 110.5%;
                        margin-left: 16px;
                      "
                    >
                      智能人货匹配
                    </div>
                    <div
                      style="height: 0.877px; background: #e5e5e5; width: 100%; margin-top: 8px"
                    ></div>
                    <div
                      style="
                        color: #6a6a7e;
                        font-family: PingFang SC;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 160%;
                        margin-left: 16px;
                        margin-top: 22px;
                      "
                    >
                      Cartsee 通过用户在广告、网站、邮件、短信等渠道的交互行为数据，建模预测用户对网站所有商品的转化可能性，并通过“猜你喜欢”等推荐功能实现千人千面的产品推荐服务，有效提升邮件、短信的营销转化率。                    </div>
                  </div>
                </div>
              </div>

              <div style="width: 581px; margin-top: 40px">
                <div style="display: flex">
                  <div>
                    <img
                      src="../assets/imgs/homeNew/chudapinci.svg"
                      alt=""
                      style="width: 75px; height: 75px"
                    />
                  </div>
                  <div>
                    <div
                      style="
                        color: #2d2d3e;
                        font-family: PingFang SC;
                        font-size: 21px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 110.5%;
                        margin-left: 16px;
                      "
                    >
                      个性化触达频次
                    </div>
                    <div
                      style="height: 0.877px; background: #e5e5e5; width: 100%; margin-top: 8px"
                    ></div>
                    <div
                      style="
                        color: #6a6a7e;
                        font-family: PingFang SC;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 160%;
                        margin-left: 16px;
                        margin-top: 22px;
                      "
                    >
                      针对不同分层不同类型的用户，Cartsee 邮件营销专家为卖家提供专业的发送解决方案，以满足多样化的用户需求。
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img
                src="../assets/imgs/homeNew/zhinengyonghufenceng.svg"
                alt=""
                style="width: 724px; height: 696px"
              />
            </div>
          </div>
          </transition>

          <transition name="fade1">
          <!-- 商品精准推荐tab下的内容 -->
          <div
            style="display: flex; padding-bottom: 80px; justify-content: space-between"
            v-if="selectedOption === '2'"
          >
            <div style="margin-top: 81px">
              <div style="width: 581px">
                <div style="display: flex">
                  <div>
                    <img
                      src="../assets/imgs/homeNew/new.svg"
                      alt=""
                      style="width: 75px; height: 75px"
                    />
                  </div>
                  <div>
                    <div
                      style="
                        color: #2d2d3e;
                        font-family: PingFang SC;
                        font-size: 21px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 110.5%;
                        margin-left: 16px;
                      "
                    >
                      新品精准推
                    </div>
                    <div
                      style="height: 0.877px; background: #e5e5e5; width: 100%; margin-top: 8px"
                    ></div>
                    <div
                      style="
                        color: #6a6a7e;
                        font-family: PingFang SC;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 160%;
                        margin-left: 16px;
                        margin-top: 22px;
                      "
                    >
                      基于新款商品与已有爆款商品的价格、风格、受众等维度的相似性学习，为新款商品找到高转化的已有用户群，通过货找人提升新品转化率。
                    </div>
                  </div>
                </div>
              </div>

              <div style="width: 581px; margin-top: 40px">
                <div style="display: flex">
                  <div>
                    <img
                      src="../assets/imgs/homeNew/baopin.svg"
                      alt=""
                      style="width: 75px; height: 75px"
                    />
                  </div>
                  <div>
                    <div
                      style="
                        color: #2d2d3e;
                        font-family: PingFang SC;
                        font-size: 21px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 110.5%;
                        margin-left: 16px;
                      "
                    >
                      爆品精准推
                    </div>
                    <div
                      style="height: 0.877px; background: #e5e5e5; width: 100%; margin-top: 8px"
                    ></div>
                    <div
                      style="
                        color: #6a6a7e;
                        font-family: PingFang SC;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 160%;
                        margin-left: 16px;
                        margin-top: 22px;
                      "
                    >
                      识别近期与爆款商品有过交互但未下单的用户，动态调节爆款商品的曝光频次和节奏，有效提升爆款商品在已有用户中的销量。
                    </div>
                  </div>
                </div>
              </div>

              <div style="width: 581px; margin-top: 40px">
                <div style="display: flex">
                  <div>
                    <img
                      src="../assets/imgs/homeNew/jiaocha.svg"
                      alt=""
                      style="width: 75px; height: 75px"
                    />
                  </div>
                  <div>
                    <div
                      style="
                        color: #2d2d3e;
                        font-family: PingFang SC;
                        font-size: 21px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 110.5%;
                        margin-left: 16px;
                      "
                    >
                      交叉精准推
                    </div>
                    <div
                      style="height: 0.877px; background: #e5e5e5; width: 100%; margin-top: 8px"
                    ></div>
                    <div
                      style="
                        color: #6a6a7e;
                        font-family: PingFang SC;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 160%;
                        margin-left: 16px;
                        margin-top: 22px;
                      "
                    >
                      针对服装等品类高连带率的行业特点，基于用户历史的浏览和购买等记录，在用户点击邮件商品后，在落地页中推送个性化的置顶推荐商品，大幅提升到站转化率。
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-top: 80px">
              <img
                src="../assets/imgs/homeNew/shangpingjinzhuntuijian.svg"
                alt=""
                style="width: 589px; height: 580px"
              />
            </div>
          </div>

          </transition>

          <transition name="fade1">
           <!-- 高效邮件创作tab下的内容 -->
          <div style="display: flex; padding-bottom: 80px" v-if="selectedOption === '3'">
            <div style="margin-top: 81px">
              <div style="width: 581px">
                <div style="display: flex">
                  <div>
                    <img
                      src="../assets/imgs/homeNew/xiangzi.svg"
                      alt=""
                      style="width: 75px; height: 75px"
                    />
                  </div>
                  <div>
                    <div
                      style="
                        color: #2d2d3e;
                        font-family: PingFang SC;
                        font-size: 21px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 110.5%;
                        margin-left: 16px;
                      "
                    >
                      开箱即用
                    </div>
                    <div
                      style="height: 0.877px; background: #e5e5e5; width: 100%; margin-top: 8px"
                    ></div>
                    <div
                      style="
                        color: #6a6a7e;
                        font-family: PingFang SC;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 160%;
                        margin-left: 16px;
                        margin-top: 22px;
                      "
                    >
                      上百种电商行业邮件模板，无论是弹窗、Flow、Campaign
                      等都支持一键启用，方便高效，帮助卖家提前做好解决方案。极大提升高质量素材内容制作效率。
                    </div>
                  </div>
                </div>
              </div>

              <div style="width: 581px; margin-top: 40px">
                <div style="display: flex">
                  <div>
                    <img
                      src="../assets/imgs/homeNew/bi-1.svg"
                      alt=""
                      style="width: 75px; height: 75px"
                    />
                  </div>
                  <div>
                    <div
                      style="
                        color: #2d2d3e;
                        font-family: PingFang SC;
                        font-size: 21px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 110.5%;
                        margin-left: 16px;
                      "
                    >
                      灵活编辑器
                    </div>
                    <div
                      style="height: 0.877px; background: #e5e5e5; width: 100%; margin-top: 8px"
                    ></div>
                    <div
                      style="
                        color: #6a6a7e;
                        font-family: PingFang SC;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 160%;
                        margin-left: 16px;
                        margin-top: 22px;
                      "
                    >
                      内置拖拽式邮件编辑器的同时，也支持数十种电商场景组件，轻松降低创作难度还能延展无限可能，设计出专业且高效的邮件。
                    </div>
                  </div>
                </div>
              </div>

              <div style="width: 581px; margin-top: 40px">
                <div style="display: flex">
                  <div>
                    <img
                      src="../assets/imgs/homeNew/feng.svg"
                      alt=""
                      style="width: 75px; height: 75px"
                    />
                  </div>
                  <div>
                    <div
                      style="
                        color: #2d2d3e;
                        font-family: PingFang SC;
                        font-size: 21px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 110.5%;
                        margin-left: 16px;
                      "
                    >
                      多场景
                    </div>
                    <div
                      style="height: 0.877px; background: #e5e5e5; width: 100%; margin-top: 8px"
                    ></div>
                    <div
                      style="
                        color: #6a6a7e;
                        font-family: PingFang SC;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 160%;
                        margin-left: 16px;
                        margin-top: 22px;
                      "
                    >
                      支持邮件和短信多渠道多触点，匹配同步用户偏好，在用户生命周期内进行精准、及时触达。满足用户体验的基础上带来
                      GMV 的增长。
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img
                src="../assets/imgs/homeNew/gaoxiaoyoujianchuangzuo.svg"
                alt=""
                style="width: 589px; height: 564px;"
              />
            </div>
          </div>
          </transition>

          <transition name="fade1">
                     <!-- 卓越通道效果 -->
          <div
            style="display: flex; padding-bottom: 80px; justify-content: space-between"
            v-if="selectedOption === '4'"
          >
            <div style="margin-top: 81px">
              <div style="width: 581px">
                <div style="display: flex">
                  <div>
                    <img
                      src="../assets/imgs/homeNew/ipyure.svg"
                      alt=""
                      style="width: 75px; height: 75px"
                    />
                  </div>
                  <div>
                    <div
                      style="
                        color: #2d2d3e;
                        font-family: PingFang SC;
                        font-size: 21px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 110.5%;
                        margin-left: 16px;
                      "
                    >
                    IP-Warming
                    </div>
                    <div
                      style="height: 0.877px; background: #e5e5e5; width: 100%; margin-top: 8px"
                    ></div>
                    <div
                      style="
                        color: #6a6a7e;
                        font-family: PingFang SC;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 160%;
                        margin-left: 16px;
                        margin-top: 22px;
                      "
                    >
                      CartSee 专家团队提供科学的 IP
                      预热方法论，能帮助卖家快速建立和加强邮件服务提供商对发送方IP地址的信任，打好地基的同时保障通道送达、进箱持续稳定。
                    </div>
                  </div>
                </div>
              </div>

              <div style="width: 581px; margin-top: 40px">
                <div style="display: flex">
                  <div>
                    <img
                      src="../assets/imgs/homeNew/ju.svg"
                      alt=""
                      style="width: 75px; height: 75px"
                    />
                  </div>
                  <div>
                    <div
                      style="
                        color: #2d2d3e;
                        font-family: PingFang SC;
                        font-size: 21px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 110.5%;
                        margin-left: 16px;
                      "
                    >
                      通道矩阵
                    </div>
                    <div
                      style="height: 0.877px; background: #e5e5e5; width: 100%; margin-top: 8px"
                    ></div>
                    <div
                      style="
                        color: #6a6a7e;
                        font-family: PingFang SC;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 160%;
                        margin-left: 16px;
                        margin-top: 22px;
                      "
                    >
                      智能通道矩阵解决方案在进行邮件发送时，根据发送用户的活跃程度，自动匹配最适合的通道，确保用户的送达及打开率达到最优状态。
                    </div>
                  </div>
                </div>
              </div>

              <div style="width: 581px; margin-top: 40px">
                <div style="display: flex">
                  <div>
                    <img
                      src="../assets/imgs/homeNew/ren-1.svg"
                      alt=""
                      style="width: 75px; height: 75px"
                    />
                  </div>
                  <div>
                    <div
                      style="
                        color: #2d2d3e;
                        font-family: PingFang SC;
                        font-size: 21px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 110.5%;
                        margin-left: 16px;
                      "
                    >
                      白名单
                    </div>
                    <div
                      style="height: 0.877px; background: #e5e5e5; width: 100%; margin-top: 8px"
                    ></div>
                    <div
                      style="
                        color: #6a6a7e;
                        font-family: PingFang SC;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 160%;
                        margin-left: 16px;
                        margin-top: 22px;
                      "
                    >
                      专业的智能分类功能,保证定向邮件的高打开和高转化,为潜在的发送问题提供保障。
                    </div>
                  </div>
                </div>
              </div>

              <div style="width: 581px; margin-top: 40px">
                <div style="display: flex">
                  <div>
                    <img
                      src="../assets/imgs/homeNew/ip-1-1.svg"
                      alt=""
                      style="width: 75px; height: 75px"
                    />
                  </div>
                  <div>
                    <div
                      style="
                        color: #2d2d3e;
                        font-family: PingFang SC;
                        font-size: 21px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 110.5%;
                        margin-left: 16px;
                      "
                    >
                      独立IP
                    </div>
                    <div
                      style="height: 0.877px; background: #e5e5e5; width: 100%; margin-top: 8px"
                    ></div>
                    <div
                      style="
                        color: #6a6a7e;
                        font-family: PingFang SC;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 160%;
                        margin-left: 16px;
                        margin-top: 22px;
                      "
                    >
                      CartSee 根据企业的量级量身打造多个专属独立
                      IP，提高抗风险能力以及可持续优化能力，优化调整更加可控。
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div >
              <img
                src="../assets/imgs/homeNew/zhuoyuetongdao.svg"
                alt=""
                style="width: 724px; height: 670px"
              />
            </div>
          </div>
          </transition>

        </div>

        <!-- 主页的  CartSee 营销自动化平台部分-->
        <div v-if="headerCheck === 'home' || bannerCheck === ''">
          <div style="width: 590px; margin: 0 auto">
            <div style="width: 100%; padding-left: 119px">
              <img
                src="../assets/imgs/homeNew/Ellipse1.svg"
                alt=""
                style="width: 46px; height: 23px"
              />
            </div>

            <div
              style="
                color: #060640;
                text-align: center;
                font-family: PingFang SC;
                font-size: 44px;
                font-style: normal;
                font-weight: 500;
                line-height: 55px;
                margin-top: 2px;
              "
            >
              CartSee 营销自动化平台
            </div>
            <div
              style="
                width: 100%;
                color: #6a6a7e;
                text-align: center;
                font-family: PingFang SC;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 28px;
                margin-top: 12px;
              "
            >
              为各行业卖家定制一站式自动化运营方案，包括弹窗、Flow、Campaign、用户群、发送内容、模板等。帮助卖家触达用户提高转化。
            </div>
          </div>

          <div
            style="
              width: 910px;
              margin: 60px auto 100px;
              display: flex;
              justify-content: space-between;
            "
          >
            <div>
              <div
                style="
                  color: #292930;
                  font-family: Noto Sans;
                  font-size: 11.225px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: 156.5%;
                  letter-spacing: 1.515px;
                  text-transform: uppercase;
                "
              >
                <span
                  style="
                    color: #333af4;
                    font-family: Noto Sans;
                    font-size: 11.225px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 156.5%;
                    letter-spacing: 1.515px;
                    text-transform: uppercase;
                  "
                  >//</span
                >
                01 . CAMPAIGN
              </div>
              <div
                style="
                  color: #292930;
                  font-family: PingFang SC;
                  font-size: 26px;
                  font-style: normal;
                  font-weight: 600;
                  line-height: 110.5%;
                  margin-top: 11px;
                "
              >
                营销活动
              </div>
              <div
                style="
                  width: 368px;
                  color: #6a6a7e;
                  font-family: PingFang SC;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 28px;
                  margin-top: 22px;
                "
              >
              营销活动是卖家主动触达用户的营销工具，Cartsee提供包括邮件、短信、APP Push 等渠道的营销能力。并且通过优化邮件、短信的送达、打开、点击等全流程漏斗数据，使每一封邮件的效果最大化。
              </div>

              <div style="display: flex; justify-content: space-between; margin-top: 34px">
                <!-- 左半边 -->
                <div>
                  <div style="display: flex; height: 15px">
                    <img
                      src="../assets/imgs/homeNew/ok.svg"
                      alt=""
                      style="width: 14px; height: 14px"
                    />
                    <div
                      style="
                        color: #292930;
                        font-family: PingFang SC;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 110.5%;
                        margin-left: 12px;
                      "
                    >
                      充分了解您的商品数据
                    </div>
                  </div>
                  <div style="display: flex; height: 15px; margin-top: 24px">
                    <img
                      src="../assets/imgs/homeNew/ok.svg"
                      alt=""
                      style="width: 14px; height: 14px"
                    />
                    <div
                      style="
                        color: #292930;
                        font-family: PingFang SC;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 110.5%;
                        margin-left: 12px;
                      "
                    >
                      智能猜你喜欢
                    </div>
                  </div>
                  <div style="display: flex; height: 15px; margin-top: 24px">
                    <img
                      src="../assets/imgs/homeNew/ok.svg"
                      alt=""
                      style="width: 14px; height: 14px"
                    />
                    <div
                      style="
                        color: #292930;
                        font-family: PingFang SC;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 110.5%;
                        margin-left: 12px;
                      "
                    >
                      丰富的邮件模板
                    </div>
                  </div>
                  <div style="display: flex; height: 15px; margin-top: 24px">
                    <img
                      src="../assets/imgs/homeNew/ok.svg"
                      alt=""
                      style="width: 14px; height: 14px"
                    />
                    <div
                      style="
                        color: #292930;
                        font-family: PingFang SC;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 110.5%;
                        margin-left: 12px;
                      "
                    >
                      高效邮件编辑器
                    </div>
                  </div>
                </div>
                <!-- 右半边 -->
                <div>
                  <div style="display: flex; height: 15px">
                    <img
                      src="../assets/imgs/homeNew/ok.svg"
                      alt=""
                      style="width: 14px; height: 14px"
                    />
                    <div
                      style="
                        color: #292930;
                        font-family: PingFang SC;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 110.5%;
                        margin-left: 12px;
                      "
                    >
                      双模式营销渠道
                    </div>
                  </div>
                  <div style="display: flex; height: 15px; margin-top: 24px">
                    <img
                      src="../assets/imgs/homeNew/ok.svg"
                      alt=""
                      style="width: 14px; height: 14px"
                    />
                    <div
                      style="
                        color: #292930;
                        font-family: PingFang SC;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 110.5%;
                        margin-left: 12px;
                      "
                    >
                      AB测试优化决策
                    </div>
                  </div>
                  <div style="display: flex; height: 15px; margin-top: 24px">
                    <img
                      src="../assets/imgs/homeNew/ok.svg"
                      alt=""
                      style="width: 14px; height: 14px"
                    />
                    <div
                      style="
                        color: #292930;
                        font-family: PingFang SC;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 110.5%;
                        margin-left: 12px;
                      "
                    >
                      邮件推送再营销
                    </div>
                  </div>
                </div>
              </div>

              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-radius: 7px;
                  border: 1px solid #4e5363;
                  background: #fff;
                  width: 142px;
                  height: 64px;
                  margin-top: 42px;
                  cursor: pointer;
                  font-size: 18px;
                "
                @click="campAbout"
              >
                了解更多
                <img
                  src="../assets/imgs/homeNew/Vector1.svg"
                  alt=""
                  style="margin-left: 8px; width: 14px; height: 14px"
                />
              </div>
            </div>

            <div style="width: 393px; height: 531px; margin-left: 109px">
              <img
                src="../assets/imgs/homeNew/zhinengyonghubanner1.svg"
                alt=""
                style="width: 100%; height: 100%"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 主页的 蓝底色的内容  营销流程-->
      <div
        v-if="headerCheck === 'home' || bannerCheck === ''"
        style="
          width: 100%;
          height: 767px;
          background: linear-gradient(289deg, #ecf2ff 35.35%, #ecfffa 131.65%), #ecf2ff;
          padding-top: 110px;
        "
      >
        <div
          style="margin: 0 auto; width: 1000px; height: 524px; display: flex; align-items: center;justify-content: space-between;"
        >
          <div style="width: 527px; height: 524px">
            <img
              src="../assets/imgs/homeNew/home-flow.svg"
              alt=""
              style="width: 524px; height: 487.55px"
            />
          </div>
          <div style="width: 395px; height: 374px; margin-left: 73px">
            <div
              style="
                color: #292930;
                font-family: Noto Sans;
                font-size: 11.225px;
                font-style: normal;
                font-weight: 500;
                line-height: 156.5%;
                letter-spacing: 1.515px;
                text-transform: uppercase;
                margin-bottom: 10px;
              "
            >
              <span
                style="
                  color: #333af4;
                  font-family: Noto Sans;
                  font-size: 11.225px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: 156.5%;
                  letter-spacing: 1.515px;
                  text-transform: uppercase;
                "
                >//</span
              >02 . FLOW
            </div>
            <div
              style="
                color: #292930;
                font-family: PingFang SC;
                font-size: 26px;
                font-style: normal;
                font-weight: 600;
                line-height: 110.5%;
              "
            >
              营销流程
            </div>
            <div
              style="
                color: #6a6a7e;
                font-family: PingFang SC;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 28px;
                width: 395px;
                margin-top: 24px;
              "
            >
            营销流程是基于用户的电商购物车场景预设的自动化触达工具，通过高相关性、高时效性、千人千面的营销信息推送，大幅提升首单用户转化，有效提升网站转化率。
            </div>

            <div style="display: flex; justify-content: space-between; margin-top: 40px">
              <!-- 左半边 -->
              <div>
                <div style="display: flex; height: 15px">
                  <img
                    src="../assets/imgs/homeNew/ok.svg"
                    alt=""
                    style="width: 14px; height: 14px"
                  />
                  <div
                    style="
                      color: #292930;
                      font-family: PingFang SC;
                      font-size: 14px;
                      font-style: normal;
                      font-weight: 500;
                      line-height: 110.5%;
                      margin-left: 12px;
                    "
                  >
                    高效模板一键启用
                  </div>
                </div>
                <div style="display: flex; height: 15px; margin-top: 24px">
                  <img
                    src="../assets/imgs/homeNew/ok.svg"
                    alt=""
                    style="width: 14px; height: 14px"
                  />
                  <div
                    style="
                      color: #292930;
                      font-family: PingFang SC;
                      font-size: 14px;
                      font-style: normal;
                      font-weight: 500;
                      line-height: 110.5%;
                      margin-left: 12px;
                    "
                  >
                    精细化运营
                  </div>
                </div>
                <div style="display: flex; height: 15px; margin-top: 24px">
                  <img
                    src="../assets/imgs/homeNew/ok.svg"
                    alt=""
                    style="width: 14px; height: 14px"
                  />
                  <div
                    style="
                      color: #292930;
                      font-family: PingFang SC;
                      font-size: 14px;
                      font-style: normal;
                      font-weight: 500;
                      line-height: 110.5%;
                      margin-left: 12px;
                    "
                  >
                    AB测试优化决策
                  </div>
                </div>
              </div>
              <!-- 右半边 -->
              <div>
                <div style="display: flex; height: 15px">
                  <img
                    src="../assets/imgs/homeNew/ok.svg"
                    alt=""
                    style="width: 14px; height: 14px"
                  />
                  <div
                    style="
                      color: #292930;
                      font-family: PingFang SC;
                      font-size: 14px;
                      font-style: normal;
                      font-weight: 500;
                      line-height: 110.5%;
                      margin-left: 12px;
                    "
                  >
                    可扩展的自定义流程
                  </div>
                </div>
                <div style="display: flex; height: 15px; margin-top: 24px">
                  <img
                    src="../assets/imgs/homeNew/ok.svg"
                    alt=""
                    style="width: 14px; height: 14px"
                  />
                  <div
                    style="
                      color: #292930;
                      font-family: PingFang SC;
                      font-size: 14px;
                      font-style: normal;
                      font-weight: 500;
                      line-height: 110.5%;
                      margin-left: 12px;
                    "
                  >
                    双模式营销渠道
                  </div>
                </div>
                <div style="display: flex; height: 15px; margin-top: 24px">
                  <img
                    src="../assets/imgs/homeNew/ok.svg"
                    alt=""
                    style="width: 14px; height: 14px"
                  />
                  <div
                    style="
                      color: #292930;
                      font-family: PingFang SC;
                      font-size: 14px;
                      font-style: normal;
                      font-weight: 500;
                      line-height: 110.5%;
                      margin-left: 12px;
                    "
                  >
                    妥投邀评
                  </div>
                </div>
              </div>
            </div>

            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                color: #292930;
                font-family: PingFang SC;
                font-size: 18px;
                font-style: normal;
                font-weight: 400;
                line-height: 160%;
                text-transform: capitalize;
                border-radius: 7px;
                background: #fff;
                width: 142px;
                height: 64px;
                margin-top: 40px;
                cursor: pointer;
              "
              @click="flowAbout"
            >
              了解更多<img
                src="../assets/imgs/homeNew/Vector1.svg"
                alt=""
                style="margin-left: 8px; width: 14px; height: 14px"
              />
            </div>
          </div>
        </div>
      </div>

      <!--  主页的 用户细分 -->
      <div
        v-if="headerCheck === 'home' || bannerCheck === ''"
        style="width: 100%; height: 767px; background: #fff; display: flex; align-items: center"
      >
        <div
          style="
            width: 970px;
            height: 430px;
            display: flex;
            margin: 0 auto;
            justify-content: space-between;
          "
        >
          <div style="width: 395px; height: 374px;">
            <div
              style="
                color: #292930;
                font-family: Noto Sans;
                font-size: 11.225px;
                font-style: normal;
                font-weight: 500;
                line-height: 156.5%;
                letter-spacing: 1.515px;
                text-transform: uppercase;
                margin-bottom: 10px;
              "
            >
              <span
                style="
                  color: #333af4;
                  font-family: Noto Sans;
                  font-size: 11.225px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: 156.5%;
                  letter-spacing: 1.515px;
                  text-transform: uppercase;
                "
                >//</span
              >03 . USER SEGMENTATION
            </div>
            <div
              style="
                color: #292930;
                font-family: PingFang SC;
                font-size: 26px;
                font-style: normal;
                font-weight: 600;
                line-height: 110.5%;
              "
            >
            用户群
            </div>
            <div
              style="
                color: #6a6a7e;
                font-family: PingFang SC;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 28px;
                width: 410px;
                margin-top: 24px;
              "
            >
            用户群是卖家在 Cartsee 中高频使用的工具，商家根据用户属性偏好、行为标签、历史消费特征等用户数据，创建出需要符合运营需求的人群包，用于在营销流程和营销活动中精细化触达。
            </div>

            <div style="display: flex; justify-content: space-between; margin-top: 40px">
              <!-- 左半边 -->
              <div>
                <div style="display: flex; height: 15px">
                  <img
                    src="../assets/imgs/homeNew/ok.svg"
                    alt=""
                    style="width: 14px; height: 14px"
                  />
                  <div
                    style="
                      color: #292930;
                      font-family: PingFang SC;
                      font-size: 14px;
                      font-style: normal;
                      font-weight: 500;
                      line-height: 110.5%;
                      margin-left: 12px;
                    "
                  >
                    智能用户细分
                  </div>
                </div>
                <div style="display: flex; height: 15px; margin-top: 24px">
                  <img
                    src="../assets/imgs/homeNew/ok.svg"
                    alt=""
                    style="width: 14px; height: 14px"
                  />
                  <div
                    style="
                      color: #292930;
                      font-family: PingFang SC;
                      font-size: 14px;
                      font-style: normal;
                      font-weight: 500;
                      line-height: 110.5%;
                      margin-left: 12px;
                    "
                  >
                    用户分层标签
                  </div>
                </div>
                <div style="display: flex; height: 15px; margin-top: 24px">
                  <img
                    src="../assets/imgs/homeNew/ok.svg"
                    alt=""
                    style="width: 14px; height: 14px"
                  />
                  <div
                    style="
                      color: #292930;
                      font-family: PingFang SC;
                      font-size: 14px;
                      font-style: normal;
                      font-weight: 500;
                      line-height: 110.5%;
                      margin-left: 12px;
                    "
                  >
                    商品匹配人群
                  </div>
                </div>
              </div>
            </div>

            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                color: #292930;
                font-family: PingFang SC;
                font-size: 18px;
                font-style: normal;
                font-weight: 400;
                line-height: 160%;
                text-transform: capitalize;
                border-radius: 7px;
                background: #fff;
                border: 1px solid #4e5363;
                width: 142px;
                height: 64px;
                margin-top: 40px;
                cursor: pointer;
              "
              @click="userAbout"
            >
              了解更多<img
                src="../assets/imgs/homeNew/Vector1.svg"
                alt=""
                style="margin-left: 8px; width: 14px; height: 14px"
              />
            </div>
          </div>
          <div style="width: 460px; height: 414px">
            <img
              src="../assets/imgs/homeNew/home-user-xifen.svg"
              alt=""
              style="width: 460px; height: 414px"
            />
          </div>
        </div>
      </div>

      <!-- 主页的 收集弹窗 -->
      <div
        v-if="headerCheck === 'home' || bannerCheck === ''"
        style="
          width: 100%;
          height: 767px;
          display: flex;
          align-items: center;
          background: linear-gradient(289deg, #ecf2ff 35.35%, #ecfffa 131.65%), #ecf2ff;
        "
      >
        <div
          style="
            width: 970px;
            height: 430px;
            display: flex;
            margin: 0 auto;
            justify-content: space-between;
          "
        >
          <div style="width: 460px; height: 414px;">
            <img
              src="../assets/imgs/homeNew/home-tanchuan.svg"
              alt=""
              style="width: 460px; height: 414px"
            />
          </div>
          <div style="width: 395px; height: 374px">
            <div
              style="
                color: #292930;
                font-family: Noto Sans;
                font-size: 11.225px;
                font-style: normal;
                font-weight: 500;
                line-height: 156.5%;
                letter-spacing: 1.515px;
                text-transform: uppercase;
                margin-bottom: 10px;
              "
            >
              <span
                style="
                  color: #333af4;
                  font-family: Noto Sans;
                  font-size: 11.225px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: 156.5%;
                  letter-spacing: 1.515px;
                  text-transform: uppercase;
                "
                >//</span
              >04 . Sign-up forms
            </div>
            <div
              style="
                color: #292930;
                font-family: PingFang SC;
                font-size: 26px;
                font-style: normal;
                font-weight: 600;
                line-height: 110.5%;
              "
            >
            弹窗工具
            </div>
            <div
              style="
                color: #6a6a7e;
                font-family: PingFang SC;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 28px;
                width: 395px;
                margin-top: 24px;
              "
            >
            弹窗工具是卖家在网站上预设的获得用户留邮的有效工具，Cartsee 提供一系列的高提交率、游戏化的弹窗模板，帮助卖家二次触达用户获得转化。并通过AB测试工具帮助卖家提供持续优化能力，获得可评测的网站转化率提升。
            </div>

            <div style="display: flex; justify-content: space-between; margin-top: 40px">
              <!-- 左半边 -->
              <div>
                <div style="display: flex; height: 15px">
                  <img
                    src="../assets/imgs/homeNew/ok.svg"
                    alt=""
                    style="width: 14px; height: 14px"
                  />
                  <div
                    style="
                      color: #292930;
                      font-family: PingFang SC;
                      font-size: 14px;
                      font-style: normal;
                      font-weight: 500;
                      line-height: 110.5%;
                      margin-left: 12px;
                    "
                  >
                    高提交率的弹窗模板
                  </div>
                </div>
                <div style="display: flex; height: 15px; margin-top: 24px">
                  <img
                    src="../assets/imgs/homeNew/ok.svg"
                    alt=""
                    style="width: 14px; height: 14px"
                  />
                  <div
                    style="
                      color: #292930;
                      font-family: PingFang SC;
                      font-size: 14px;
                      font-style: normal;
                      font-weight: 500;
                      line-height: 110.5%;
                      margin-left: 12px;
                    "
                  >
                    体验感 — 大转盘
                  </div>
                </div>
              </div>

              <div>
                <div style="display: flex; height: 15px">
                  <img
                    src="../assets/imgs/homeNew/ok.svg"
                    alt=""
                    style="width: 14px; height: 14px"
                  />
                  <div
                    style="
                      color: #292930;
                      font-family: PingFang SC;
                      font-size: 14px;
                      font-style: normal;
                      font-weight: 500;
                      line-height: 110.5%;
                      margin-left: 12px;
                    "
                  >
                    自定义收集信息
                  </div>
                </div>
                <div style="display: flex; height: 15px; margin-top: 24px">
                  <img
                    src="../assets/imgs/homeNew/ok.svg"
                    alt=""
                    style="width: 14px; height: 14px"
                  />
                  <div
                    style="
                      color: #292930;
                      font-family: PingFang SC;
                      font-size: 14px;
                      font-style: normal;
                      font-weight: 500;
                      line-height: 110.5%;
                      margin-left: 12px;
                    "
                  >
                    个性化信息分类
                  </div>
                </div>
              </div>
            </div>

            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                color: #292930;
                font-family: PingFang SC;
                font-size: 18px;
                font-style: normal;
                font-weight: 400;
                line-height: 160%;
                text-transform: capitalize;
                border-radius: 7px;
                background: #fff;
                border: 1px solid #4e5363;
                width: 142px;
                height: 64px;
                margin-top: 40px;
                cursor: pointer;
              "
              @click="tanchuanAbout"
            >
              了解更多<img
                src="../assets/imgs/homeNew/Vector1.svg"
                alt=""
                style="margin-left: 8px; width: 14px; height: 14px"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- 主页的 客户成功 & 解决方案专家团队-->
      <div
        v-if="headerCheck === 'home' || bannerCheck === ''"
        style="
          width: 100%;
          display: flex;
          align-items: center;
          background: #fff;
          padding-top: 80px;
        "
      >
        <div style="width: 1185px; height: 650px; display: flex; margin: 0 auto;align-items: center;justify-content: space-between;">
          <div>
            <div
              style="
                color: var(--Primary, #060640);
                font-family: PingFang SC;
                font-size: 45px;
                font-style: normal;
                font-weight: 500;
                line-height: 55px;
                position: relative;
              "
            >
              客户成功
              <br />
              <div style="width: 100%; position: absolute;left: 250px;top: 11px;">
              <img
                src="../assets/imgs/homeNew/Ellipse1.svg"
                alt=""
                style="width: 46px; height: 23px"
              />
            </div>
              & 解决方案专家团队
            </div>
            <div
              style="
                width: 500px;
                color: #6a6a7e;
                font-family: PingFang SC;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 28px;
                margin-top: 39px;
              "
            >
              跨境电商邮件及短信营销增长乏力？ROI 不理想？想优化又不知道如何下手？Cartsee 的客户成功团队为您提供全程陪伴式的咨询服务和优化建议。帮助卖家找到问题点，提供优化方案建议。Cartsee 客户成功以客户的营收增长为首要目标，帮助客户持续成功。
            </div>
          </div>

          <div style="width: 708px; height: 650px">
            <img
              src="../assets/imgs/homeNew/home-kehuchenggong.svg"
              alt=""
              style="width: 708px; height: 650px"
            />
          </div>
        </div>
      </div>

      <!-- 主页的客户案例 -->
      <div
        v-if="headerCheck === 'home' || bannerCheck === ''"
        style="
          width: 100%;
          display: flex;
          align-items: center;
          background: #fff;
          padding-top: 100px;
        "
        ref="customerCase"
      >
        <div style="width: 1185px; height: 1200px; margin: 0 auto">
          <div style="width: 200px; margin: 0 auto; padding-left: 100px">
            <img
              src="../assets/imgs/homeNew/Ellipse1.svg"
              alt=""
              style="width: 46px; height: 23px"
            />
          </div>
          <div
            style="
              color: #060640;
              text-align: center;
              font-family: PingFang SC;
              font-size: 45px;
              font-style: normal;
              font-weight: 500;
              line-height: 55px;
            "
          >
            客户案例
          </div>

          <div
            style="
              display: flex;
              width: 1170px;
              padding: 85px 90px;
              border-radius: 10px;
              background: #edfafc;
              margin-top: 54px;
              flex-direction: column;
            "
          >
            <div style="display: flex; justify-content: space-between; height: 45px; width: 990px">
              <div>
                <img
                  src="../assets/imgs/homeNew/home-ogl.png"
                  alt=""
                  style="width: 112px; height: 18px"
                />
              </div>
              <div
                style="
                  width: 369px;
                  height: 45px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  color: #292930;
                  font-family: Noto Sans;
                  font-size: 15px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: 156.5%;
                  letter-spacing: 2.025px;
                  text-transform: uppercase;
                  border-radius: 25px;
                  border: 1px solid rgba(41, 41, 48);
                "
              >
                服装行业卖家 September 1, 2022
              </div>
            </div>

            <div
              style="
                margin-top: 26px;
                color: #555;
                font-family: PingFang SC;
                font-size: 18px;
                font-style: normal;
                font-weight: 400;
                line-height: 215%;
                width: 990px;
              "
            >
              我们是 OGL，一直深耕欧美环保服装这条赛道。我们之前的营销策略缺乏个性化和针对性，用户参与度和转化率一直难以提升。广泛的群发导致信息的低效传达，用户的反馈也相对较弱。
              引入了 CartSee
              之后，确实颠覆了我们的之前的想象，弹窗功能不仅提高了用户互动，而且在关键时刻巧妙出现，收集到更多活跃用户。个性化邮件发送的千人千面策略，使我们能够更精准地触达用户，解决了以往营销的盲目性。
              最重要的是，我们的邮件点击率平均提高了 <span style="color: #333af4;font-weight: 500;">20.28 %</span>，最高时点击率能到
              <span style="color: #333af4;font-weight: 500;">80%</span> ，转化率也平均提升了
              <span style="color: #333af4;font-weight: 500;">15%</span> 。数据不折不扣地证明了确实效性。作为中国卖家，Cartsee 的本土化设计为我们赢得了更多用户和收益。很给力，点赞！！！
            </div>
          </div>

          <div
            style="
              display: flex;
              width: 1170px;
              padding: 85px 90px;
              border-radius: 10px;
              background: #e9f1ff;
              margin-top: 54px;
              flex-direction: column;
            "
          >
            <div style="display: flex; justify-content: space-between; height: 45px; width: 990px">
              <div>
                <img
                  src="../assets/imgs/homeNew/home-silksilky.svg"
                  alt=""
                  style="width: 112px; height: 18px"
                />
              </div>
              <div
                style="
                  width: 369px;
                  height: 45px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  color: #292930;
                  font-family: Noto Sans;
                  font-size: 15px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: 156.5%;
                  letter-spacing: 2.025px;
                  text-transform: uppercase;
                  border-radius: 25px;
                  border: 1px solid #292930;
                "
              >
                美妆行业卖家 September 1, 2022
              </div>
            </div>

            <div
              style="
                margin-top: 26px;
                color: #555;
                font-family: PingFang SC;
                font-size: 18px;
                font-style: normal;
                font-weight: 400;
                line-height: 215%;
                width: 990px;
              "
            >
              遇到 CartSee
              之前，我们一直在寻找提高营收的有效途径。过去的尝试往往难以产生实质性的效果，尤其是在发邮件这个问题上，我们的邮件经常被拦截或者被归类为垃圾邮件，导致了许多潜在客户无法接收到我们的信息。
              后来，用了 CartSee，他们的智能算法和专业技术保障了我们的邮件送达率能高达
              <span style="color: #333af4;font-weight: 500;">99%</span> ，并且能在用户收件箱中脱颖而出，比之前的打开率提高了很多。另外，CartSee
              的专家团队对我们的业务理解非常深度，在营销过程中，我们时常遇到一些具体问题，专家团队总是能及时响应并为我们量身定制更符合我们需求的解决方案，紧接着转化就能往上升。
            </div>
          </div>
        </div>
      </div>

      <!-- 主页的亮点功能 -->
      <div
        v-if="headerCheck === 'home' || bannerCheck === ''"
        style="width: 100%; background: #fff"
      >
        <div style="width: 1248px; height: 705px; margin: 0 auto">
          <div style="width: 576px; margin: 0 auto">
            <div style="width: 180px; margin: 0 auto">
              <img
                src="../assets/imgs/homeNew/Ellipse.svg"
                alt=""
                style="width: 36px; height: 18px; margin-left: 10px"
              />
            </div>
            <div
              style="
                color: #060640;
                text-align: center;
                font-family: PingFang SC;
                font-size: 45px;
                font-style: normal;
                font-weight: 500;
                line-height: 55px;
                width: 180px;
                margin: 0 auto;
              "
            >
              亮点功能
            </div>
            <div
              style="
                color: #6a6a7e;
                text-align: center;
                font-family: PingFang SC;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 28px;
                width: 576px;
                margin-top: 12px;
              "
            >
              强大的智能工具和简化操作，可节省更多的时间和金钱，带来更大的收益和未来。
            </div>
          </div>

          <div
            style="margin-top: 108px; width: 1248px; height: 404px; display: flex; flex-wrap: wrap"
          >
            <div
              style="
                width: calc(25% - 10px);
                height: calc(33.33% - 10px);
                margin: 5px;
                display: flex;
              "
            >
              <div style="width: 42px; height: 42px">
                <img
                  src="../assets/imgs/homeNew/dianjifenbutu.svg"
                  alt=""
                  style="width: 100%; height: 100%"
                />
              </div>
              <div style="margin-left: 12px; width: 172px">
                <div
                  style="
                    color: #060640;
                    font-family: PingFang SC;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 100%;
                  "
                >
                  点击分布图
                </div>
                <div
                  style="
                    width: 172px;
                    color: #6b6a7e;
                    font-family: PingFang SC;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 140%;
                    margin-top: 9px;
                  "
                >
                  查看每个板块的点击率和转化率
                </div>
              </div>
            </div>
            <div
              style="
                width: calc(25% - 10px);
                height: calc(33.33% - 10px);
                margin: 5px;
                display: flex;
              "
            >
              <div style="width: 42px; height: 42px">
                <img
                  src="../assets/imgs/homeNew/cainixihuan1.svg"
                  alt=""
                  style="width: 100%; height: 100%"
                />
              </div>
              <div style="margin-left: 12px; width: 172px">
                <div
                  style="
                    color: #060640;
                    font-family: PingFang SC;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 100%;
                  "
                >
                  猜你喜欢
                </div>
                <div
                  style="
                    width: 172px;
                    color: #6b6a7e;
                    font-family: PingFang SC;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 140%;
                    margin-top: 9px;
                  "
                >
                  不同用户的兴趣和偏好各异,个性化推荐商品
                </div>
              </div>
            </div>
            <div
              style="
                width: calc(25% - 10px);
                height: calc(33.33% - 10px);
                margin: 5px;
                display: flex;
              "
            >
              <div style="width: 42px; height: 42px">
                <img
                  src="../assets/imgs/homeNew/hailiangmoban1.svg"
                  alt=""
                  style="width: 100%; height: 100%"
                />
              </div>
              <div style="margin-left: 12px; width: 172px">
                <div
                  style="
                    color: #060640;
                    font-family: PingFang SC;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 100%;
                  "
                >
                  海量模板
                </div>
                <div
                  style="
                    width: 172px;
                    color: #6b6a7e;
                    font-family: PingFang SC;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 140%;
                    margin-top: 9px;
                  "
                >
                  海量专业级邮件模板,开箱即用
                </div>
              </div>
            </div>
            <div
              style="
                width: calc(25% - 10px);
                height: calc(33.33% - 10px);
                margin: 5px;
                display: flex;
              "
            >
              <div style="width: 42px; height: 42px">
                <img
                  src="../assets/imgs/homeNew/youjianbianjiqi.svg"
                  alt=""
                  style="width: 100%; height: 100%"
                />
              </div>
              <div style="margin-left: 12px; width: 172px">
                <div
                  style="
                    color: #060640;
                    font-family: PingFang SC;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 100%;
                  "
                >
                  邮件编辑器
                </div>
                <div
                  style="
                    width: 172px;
                    color: #6b6a7e;
                    font-family: PingFang SC;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 140%;
                    margin-top: 9px;
                  "
                >
                  内置拖拽式邮件编辑器和 HTML 编辑器，轻松降低创作难度
                </div>
              </div>
            </div>
            <div
              style="
                width: calc(25% - 10px);
                height: calc(33.33% - 10px);
                margin: 5px;
                display: flex;
              "
            >
              <div style="width: 42px; height: 42px">
                <img
                  src="../assets/imgs/homeNew/shuangqudao.svg"
                  alt=""
                  style="width: 100%; height: 100%"
                />
              </div>
              <div style="margin-left: 12px; width: 197px">
                <div
                  style="
                    color: #060640;
                    font-family: PingFang SC;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 100%;
                  "
                >
                  双渠道
                </div>
                <div
                  style="
                    width: 197px;
                    color: #6b6a7e;
                    font-family: PingFang SC;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 140%;
                    margin-top: 9px;
                  "
                >
                  卖家通过短信和邮件与用户建立联系,提供个性化化体验
                </div>
              </div>
            </div>
            <div
              style="
                width: calc(25% - 10px);
                height: calc(33.33% - 10px);
                margin: 5px;
                display: flex;
              "
            >
              <div style="width: 42px; height: 42px">
                <img
                  src="../assets/imgs/homeNew/abtest-1-1-1.svg"
                  alt=""
                  style="width: 100%; height: 100%"
                />
              </div>
              <div style="margin-left: 12px; width: 197px">
                <div
                  style="
                    color: #060640;
                    font-family: PingFang SC;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 100%;
                  "
                >
                  AB测试
                </div>
                <div
                  style="
                    width: 197px;
                    color: #6b6a7e;
                    font-family: PingFang SC;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 140%;
                    margin-top: 9px;
                  "
                >
                  比较两封邮件标题的打开率表现,科学制定邮件策略
                </div>
              </div>
            </div>
            <div
              style="
                width: calc(25% - 10px);
                height: calc(33.33% - 10px);
                margin: 5px;
                display: flex;
              "
            >
              <div style="width: 42px; height: 42px">
                <img
                  src="../assets/imgs/homeNew/campagin-zaiyingxiao.svg"
                  alt=""
                  style="width: 100%; height: 100%"
                />
              </div>
              <div style="margin-left: 12px; width: 172px">
                <div
                  style="
                    color: #060640;
                    font-family: PingFang SC;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 100%;
                  "
                >
                  Campaign 再营销
                </div>
                <div
                  style="
                    width: 172px;
                    color: #6b6a7e;
                    font-family: PingFang SC;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 140%;
                    margin-top: 9px;
                  "
                >
                  海量专业级邮件模板,开箱即用
                </div>
              </div>
            </div>
            <div
              style="
                width: calc(25% - 10px);
                height: calc(33.33% - 10px);
                margin: 5px;
                display: flex;
              "
            >
              <div style="width: 42px; height: 42px">
                <img
                  src="../assets/imgs/homeNew/tuotouyaoping.svg"
                  alt=""
                  style="width: 100%; height: 100%"
                />
              </div>
              <div style="margin-left: 12px; width: 172px">
                <div
                  style="
                    color: #060640;
                    font-family: PingFang SC;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 100%;
                  "
                >
                  妥投邀评
                </div>
                <div
                  style="
                    width: 172px;
                    color: #6b6a7e;
                    font-family: PingFang SC;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 140%;
                    margin-top: 9px;
                  "
                >
                  将打高分的用户筛选出来,定向邀约
                </div>
              </div>
            </div>
            <div
              style="
                width: calc(25% - 10px);
                height: calc(33.33% - 10px);
                margin: 5px;
                display: flex;
              "
            >
              <div style="width: 42px; height: 42px">
                <img
                  src="../assets/imgs/homeNew/yonghufenceng.svg"
                  alt=""
                  style="width: 100%; height: 100%"
                />
              </div>
              <div style="margin-left: 12px; width: 172px">
                <div
                  style="
                    color: #060640;
                    font-family: PingFang SC;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 100%;
                  "
                >
                  用户分层
                </div>
                <div
                  style="
                    width: 172px;
                    color: #6b6a7e;
                    font-family: PingFang SC;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 140%;
                    margin-top: 9px;
                  "
                >
                  您可以运营智能用户细分,自动进行用户分层
                </div>
              </div>
            </div>
            <div
              style="
                width: calc(25% - 10px);
                height: calc(33.33% - 10px);
                margin: 5px;
                display: flex;
              "
            >
              <div style="width: 42px; height: 42px">
                <img
                  src="../assets/imgs/homeNew/yonghubiaoqian.svg"
                  alt=""
                  style="width: 100%; height: 100%"
                />
              </div>
              <div style="margin-left: 12px; width: 172px">
                <div
                  style="
                    color: #060640;
                    font-family: PingFang SC;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 100%;
                  "
                >
                  用户标签
                </div>
                <div
                  style="
                    width: 172px;
                    color: #6b6a7e;
                    font-family: PingFang SC;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 140%;
                    margin-top: 9px;
                  "
                >
                  通过用户标签,帮助卖家发送更有针对性的邮件
                </div>
              </div>
            </div>
            <div
              style="
                width: calc(25% - 10px);
                height: calc(33.33% - 10px);
                margin: 5px;
                display: flex;
              "
            >
              <div style="width: 42px; height: 42px">
                <img
                  src="../assets/imgs/homeNew/huozhaoren.svg"
                  alt=""
                  style="width: 100%; height: 100%"
                />
              </div>
              <div style="margin-left: 12px; width: 172px">
                <div
                  style="
                    color: #060640;
                    font-family: PingFang SC;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 100%;
                  "
                >
                  货找人
                </div>
                <div
                  style="
                    width: 172px;
                    color: #6b6a7e;
                    font-family: PingFang SC;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 140%;
                    margin-top: 9px;
                  "
                >
                  实现商品与目标人群的精准匹配,产品定向配对
                </div>
              </div>
            </div>
            <div
              style="
                width: calc(25% - 10px);
                height: calc(33.33% - 10px);
                margin: 5px;
                display: flex;
              "
            >
              <div style="width: 42px; height: 42px">
                <img
                  src="../assets/imgs/homeNew/shoujitanchuan-1-1-1.svg"
                  alt=""
                  style="width: 100%; height: 100%"
                />
              </div>
              <div style="margin-left: 12px; width: 172px">
                <div
                  style="
                    color: #060640;
                    font-family: PingFang SC;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 100%;
                  "
                >
                  收集弹窗
                </div>
                <div
                  style="
                    width: 172px;
                    color: #6b6a7e;
                    font-family: PingFang SC;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 140%;
                    margin-top: 9px;
                  "
                >
                  以游戏化体验提高用户感受,提升留资率
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 营销活动的content 01 充分了解您的商品数据 -->
    <div
      style="width: 100%; height: 100%; background-color: #fff"
      v-if="bannerCheck === 'campagin'"
    >
      <div
        style="
          width: 1170px;
          height: 670px;
          margin: 0px auto 0px;
          display: flex;
          justify-content: space-between;
          align-items:center;
          /* padding-top: 83px; */
        "
      >
        <div style="">
          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
            "
          >
            <span
              style="
                color: #333af4;
                font-family: Noto Sans;
                font-size: 11.225px;
                font-style: normal;
                font-weight: 500;
                line-height: 156.5%;
                letter-spacing: 1.515px;
                text-transform: uppercase;
              "
              >//</span
            >01 . Campaign
          </div>

          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 11px;
            "
          >
            充分了解您的商品数据
          </div>

          <div
            style="
              width: 490px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 22px;
            "
          >
            使用点击分布图来查看每个板块的点击率和转化率，了解邮件各个板块的用户关注程度，分析产品推荐相关性，提升精细化营销能力。
          </div>
          <div
            style="
              width: 194px;
              height: 64px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              border: 1px solid #4e5363;
              background: #fff;
              color: #292930;
              font-family: PingFang SC;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              text-transform: capitalize;
              margin-top: 33px;
              cursor: pointer;
            "
            @click="login"
          >
            免费体验 CartSee
          </div>
        </div>

        <div style=" width: 573px; height: 624px;margin-bottom: -46px;">
          <img
            src="../assets/imgs/homeNew/campagin-product1.svg"
            alt=""
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </div>
    <!-- 营销活动content   02智能猜你喜欢 -->
    <div
      style="
        width: 100%;
        height: 100%;
        background: linear-gradient(289deg, #ecf2ff 35.35%, #ecfffa 131.65%), #ecf2ff;
      "
      v-if="bannerCheck === 'campagin'"
    >
      <div
        style="
          margin: 0px auto 0px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 1170px;
          height: 707px;
        "
      >
        <div style="width: 717px; height: 521px">
          <img
            src="../assets/imgs/homeNew/campagin-02.svg"
            alt=""
            style="width: 100%; height: 100%"
          />
        </div>

        <div style="width: 386px; height: 301px">
          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
            "
          >
            // 02 . Campaign
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            智能猜你喜欢
          </div>

          <div
            style="
              width: 386px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            因为不同用户的兴趣和偏好各异，个性化推荐成为提高用户点击率的关键。通过启用猜你喜欢功能发送邮件，系统根据用户多维信息，巧妙呈现个性化商品，显著提升点击率和转化率。
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              border: 1px solid #fff;
              background: #fff;
              width: 194px;
              height: 64px;
              color: #292930;
              font-family: PingFang SC;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              text-transform: capitalize;
              margin-top: 40px;
              cursor: pointer;
            "
            @click="login"
          >
            免费体验 CartSee
          </div>
        </div>
      </div>
    </div>

    <!-- 营销活动content  03 丰富的邮件模板-->
    <div style="width: 100%; height: 100%; background: #fff" v-if="bannerCheck === 'campagin'">
      <div
        style="
          margin: 0px auto 0px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 1170px;
          height: 621px;
        "
      >
        <div style="width: 386px; height: 301px">
          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
            "
          >
            // 03 . Campaign
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            丰富的邮件模板
          </div>

          <div
            style="
              width: 386px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            邮件模板的美观和专业更加能吸引用户的点击。内置超多专业级别的邮件模板，开箱即用，帮助卖家轻松打造引人入胜的邮件内容。
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              border: 1px solid #4e5363;
              background: #fff;
              width: 194px;
              height: 64px;
              color: #292930;
              font-family: PingFang SC;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              text-transform: capitalize;
              margin-top: 40px;
              cursor: pointer;
            "
            @click="login"
          >
            免费体验 CartSee
          </div>
        </div>
        <div style="width: 756px; height: 621px">
          <!-- <el-carousel height="521px" direction="vertical" :autoplay="true" indicator-position='none'>
    <el-carousel-item key="1">
      <img src="../assets/imgs/homeNew/email-temp-1.jpg" alt="" style="height: 100%; width: 49%;display: inline;max-width: 100%;">
      <img src="../assets/imgs/homeNew/email-temp-2.jpg" alt="" style="height: 100%; width: 49%;display: inline;max-width: 100%;">
    </el-carousel-item>
    <el-carousel-item key='3'>
      <img src="../assets/imgs/homeNew/email-temp-3.png" alt="" style="height: 100%; width: 49%;display: inline;max-width: 100%;">
      <img src="../assets/imgs/homeNew/email-temp-4.jpg" alt="" style="height: 100%; width: 49%;display: inline;max-width: 100%;">
    </el-carousel-item>
    <el-carousel-item key='5'>
      <img src="../assets/imgs/homeNew/email-temp-5.jpg" alt="" style="height: 100%; width: 49%;display: inline;max-width: 100%;">
      <img src="../assets/imgs/homeNew/email-temp-6.jpg" alt="" style="height: 100%; width: 49%;display: inline;max-width: 100%;">
    </el-carousel-item>
    <el-carousel-item key='7'>
      <img src="../assets/imgs/homeNew/email-temp-7.jpg" alt="" style="height: 100%; width: 49%;display: inline;max-width: 100%;">
    </el-carousel-item>
  </el-carousel> -->
          <img
            src="../assets/imgs/homeNew/email-temp-jj.png"
            alt=""
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </div>

    <!-- 营销活动content  04 高效邮件编辑器-->
    <div
      style="
        width: 100%;
        height: 100%;
        background: linear-gradient(289deg, #ecf2ff 35.35%, #ecfffa 131.65%), #ecf2ff;
      "
      v-if="bannerCheck === 'campagin'"
    >
      <div
        style="
          margin: 0px auto 0px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 1170px;
          height: 707px;
        "
      >
        <div style="width: 717px; height: 602px;margin-top: 105px;">
          <img
            src="../assets/imgs/homeNew/campagin-04.svg"
            alt=""
            style="width: 100%; height: 100%"
          />
        </div>

        <div style="width: 386px; height: 301px">
          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
            "
          >
            // 04 . Campaign
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            高效邮件编辑器
          </div>

          <div
            style="
              width: 386px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            内置拖拽式邮件编辑器和 HTML 编辑器的同时，也可选择不同的用户行为进行编辑，轻松降低创作难度还能延展无限可能，设计出专业且高点击率的邮件
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              border: 1px solid #fff;
              background: #fff;
              width: 194px;
              height: 64px;
              color: #292930;
              font-family: PingFang SC;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              text-transform: capitalize;
              margin-top: 40px;
              cursor: pointer;
            "
            @click="login"
          >
            免费体验 CartSee
          </div>
        </div>
      </div>
    </div>

    <!-- 营销活动content 05  双模式营销渠道-->
    <div style="width: 100%; height: 100%; background: #fff" v-if="bannerCheck === 'campagin'">
      <div
        style="
          margin: 0px auto 0px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 1170px;
          height: 707px;
        "
      >
        <div style="width: 490px; height: 301px;margin-right: 105px;">
          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
            "
          >
            // 05 . Campaign
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            双模式营销渠道
          </div>

          <div
            style="
              width: 490px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            卖家通过邮件或短信与用户建立联系，提供个性化体验。找到用户最喜爱的触达方式，提高转化率和 GMV。
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              border: 1px solid #4e5363;
              background: #fff;
              width: 194px;
              height: 64px;
              color: #292930;
              font-family: PingFang SC;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              text-transform: capitalize;
              margin-top: 40px;
              cursor: pointer;
            "
            @click="login"
          >
            免费体验 CartSee
          </div>
        </div>
        <div style="width: 504.6px; height: 560.81px">
          <img
            src="../assets/imgs/homeNew/campagin-05.svg"
            alt=""
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </div>

    <!-- 营销活动content 06  AB测试优化决策-->
    <div
      style="
        width: 100%;
        height: 100%;
        background: linear-gradient(289deg, #ecf2ff 35.35%, #ecfffa 131.65%), #ecf2ff;
      "
      v-if="bannerCheck === 'campagin'"
    >
      <div
        style="
          margin: 0px auto 0px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 1170px;
          height: 707px;
        "
      >
        <div style="width: 717px; height: 521px">
          <img
            src="../assets/imgs/homeNew/campagin-06.svg"
            alt=""
            style="width: 100%; height: 100%"
          />
        </div>

        <div style="width: 386px; height: 301px">
          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
            "
          >
            // 06 . Campaign
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            AB 测试优化决策
          </div>

          <div
            style="
              width: 386px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            当你不确定哪份邮件主题更有效果时，可以运用 AB 测试，比较邮件标题的打开率表现，也可以自定义测试参数，科学制定邮件策略，提高效果和用户互动率。
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              border: 1px solid #fff;
              background: #fff;
              width: 194px;
              height: 64px;
              color: #292930;
              font-family: PingFang SC;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              text-transform: capitalize;
              margin-top: 40px;
              cursor: pointer;
            "
            @click="login"
          >
            免费体验 CartSee
          </div>
        </div>
      </div>
    </div>

    <!-- 营销活动content 07 邮件推送再营销 -->
    <div style="width: 100%; height: 100%; background: #fff" v-if="bannerCheck === 'campagin'">
      <div
        style="
          margin: 0px auto 0px;
          display: flex;
          justify-content:center;
          align-items: center;
          width: 1170px;
          height: 707px;
        "
      >
        <div style="width: 386px; height: 301px;margin-right: 98px;">
          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
            "
          >
            // 07 . Campaign
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            邮件推送再营销
          </div>

          <div
            style="
              width: 386px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            总有一些用户因为一些外界因素，没有打开或点击你的邮件，造成损失，可以使用再营销，巧妙地进行二次推送，精准触达未完成期望行为的用户，弥补流失，提升用户数据和收益。
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              border: 1px solid #4e5363;
              background: #fff;
              width: 194px;
              height: 64px;
              color: #292930;
              font-family: PingFang SC;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              text-transform: capitalize;
              margin-top: 40px;
              cursor: pointer;
            "
            @click="login"
          >
            免费体验 CartSee
          </div>
        </div>
        <div style="width: 660px; height: 570.29px">
          <img
            src="../assets/imgs/homeNew/campagin-07.svg"
            alt=""
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </div>

    <!-- 营销flowcontent 01  高效模板一键启用-->
    <div style="width: 100%; height: 100%; background: #fff" v-if="bannerCheck === 'flow'">
      <div
        style="
          margin: 0px auto 0px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 1170px;
          height: 665px;
        "
      >
        <div style="width: 450px; height: 301px;margin-right: 128px;">
          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
            "
          >
            // 01 . FLOW
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            高效模板一键启用
          </div>

          <div
            style="
              width: 450px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            搭建一封高效 Flow 邮件，往往比较困难，我们有超多场景下的流程模板，灵活调整、最佳实践、可定制任何流程。并且高效快捷的启用模板进行营销策略，提高 Flow 搭建的效率和效果。
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              border: 1px solid #4e5363;
              background: #fff;
              width: 194px;
              height: 64px;
              color: #292930;
              font-family: PingFang SC;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              text-transform: capitalize;
              margin-top: 40px;
              cursor: pointer;
            "
            @click="login"
          >
            免费体验 CartSee
          </div>
        </div>
        <div style="width: 603px; height: 622px;margin-bottom: -43px;">
          <img src="../assets/imgs/homeNew/flow-01.svg" alt="" style="width: 100%; height: 100%" />
        </div>
      </div>
    </div>

    <!-- 营销flow content 02  精细化运营-->
    <div
      style="
        width: 100%;
        height: 100%;
        background: linear-gradient(289deg, #ecf2ff 35.35%, #ecfffa 131.65%), #ecf2ff;
      "
      v-if="bannerCheck === 'flow'"
    >
      <div
        style="
          margin: 0px auto 0px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 1170px;
          height: 707px;
        "
      >
        <div style="width: 717px; height: 567px">
          <img src="../assets/imgs/homeNew/flow-02.svg" alt="" style="width: 100%; height: 100%" />
        </div>

        <div style="width: 386px">
          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
            "
          >
            // 02 . FLOW
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            精细化运营
          </div>

          <div
            style="
              width: 386px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            通过精细化运营把用户行为细分成若干种情况，多种场景，各种用户行为全覆盖。不同类型用户，触发同样操作时，也会贴合用户标签，推送不同 Flow 邮件，实现个性化触发。
          </div>

          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
              margin-top: 34px;
            "
          >
            // 03 . FLOW
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            AB测试优化决策
          </div>

          <div
            style="
              width: 386px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            在自动化发送邮件时，不知道那种主题效果更好，可以通过 AB
            测试评估渠道、激励和主题的转化效果，以数据为基础做出决策，不断优化工作流程。
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              border: 1px solid #fff;
              background: #fff;
              width: 194px;
              height: 64px;
              color: #292930;
              font-family: PingFang SC;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              text-transform: capitalize;
              margin-top: 40px;
              cursor: pointer;
            "
            @click="login"
          >
            免费体验 CartSee
          </div>
        </div>
      </div>
    </div>

    <!-- 营销flow content 04 可扩展的自定义流程 -->
    <div style="width: 100%; height: 100%; background: #fff" v-if="bannerCheck === 'flow'">
      <div
        style="
          margin: 0px auto 0px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 1170px;
          height: 707px;
        "
      >
        <div style="width: 490px; height: 301px">
          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
            "
          >
            // 04 . FLOW
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            可扩展的自定义流程
          </div>

          <div
            style="
              width: 490px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            自动化发送邮件，担心会疏忽某个场景下操作的用户，利用自定义流程涵盖所有环节，全面策略下不漏任何用户。为卖家提供覆盖用户整个生命周期的完备解决方案。
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              border: 1px solid #4e5363;
              background: #fff;
              width: 194px;
              height: 64px;
              color: #292930;
              font-family: PingFang SC;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              text-transform: capitalize;
              margin-top: 40px;
              cursor: pointer;
            "
            @click="login"
          >
            免费体验 CartSee
          </div>
        </div>
        <div style="width: 632px; height: 365px">
          <img src="../assets/imgs/homeNew/flow-04.svg" alt="" style="width: 100%; height: 100%" />
        </div>
      </div>
    </div>

    <!-- 营销flow content 05  双模式营销渠道-->
    <div
      style="
        width: 100%;
        height: 100%;
        background: linear-gradient(289deg, #ecf2ff 35.35%, #ecfffa 131.65%), #ecf2ff;
      "
      v-if="bannerCheck === 'flow'"
    >
      <div
        style="
          margin: 0px auto 0px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 1170px;
          height: 707px;
        "
      >
        <div style="width: 504.6px; height: 560.81px">
          <img src="../assets/imgs/homeNew/flow-05.svg" alt="" style="width: 100%; height: 100%" />
        </div>

        <div style="width: 490px">
          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
            "
          >
            // 05 . FLOW
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            双模式营销渠道
          </div>

          <div
            style="
              width: 490px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            卖家通过邮件或短信与用户建立联系，提供个性化体验。无论用户喜好哪种触达方式，找到用户最喜爱的触达方式，提高转化率和 GMV。
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              border: 1px solid #fff;
              background: #fff;
              width: 194px;
              height: 64px;
              color: #292930;
              font-family: PingFang SC;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              text-transform: capitalize;
              margin-top: 40px;
              cursor: pointer;
            "
            @click="login"
          >
            免费体验 CartSee
          </div>
        </div>
      </div>
    </div>

    <!-- 营销flow content 06 妥投邀评 -->
    <div style="width: 100%; height: 100%; background: #fff" v-if="bannerCheck === 'flow'">
      <div
        style="
          margin: 0px auto 0px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 1170px;
          height: 707px;
        "
      >
        <div style="width: 490px; height: 301px">
          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
            "
          >
            // 06 . FLOW
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            妥投邀评
          </div>

          <div
            style="
              width: 490px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            Flow 妥投邀评技术，不使用虚假用户评论，而是依托独立站本身真实用户，采用智能用户分层，将打高分的用户筛选出来，定向邀约，实现完全合规的评分提升。
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              border: 1px solid #4e5363;
              background: #fff;
              width: 194px;
              height: 64px;
              color: #292930;
              font-family: PingFang SC;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              text-transform: capitalize;
              margin-top: 40px;
              cursor: pointer;
            "
            @click="login"
          >
            免费体验 CartSee
          </div>
        </div>
        <div style="width: 577px; height: 456px">
          <img src="../assets/imgs/homeNew/flow-06.svg" alt="" style="width: 100%; height: 100%" />
        </div>
      </div>
    </div>

    <!-- 营销flow content 预设Flow流程，为您提高效率 -->
    <div style="width: 100%; height: 100%; background: #fff" v-if="bannerCheck === 'flow'">
      <div style="width: 36px; margin: 0 auto">
        <img
          src="../assets/imgs/homeNew/Ellipse.svg"
          alt=""
          style="width: 36px; height: 18px; margin-left: 200px"
        />
      </div>
      <div
        style="
          width: 687px;
          color: #060640;
          text-align: center;
          font-family: PingFang SC;
          font-size: 45px;
          font-style: normal;
          font-weight: 500;
          line-height: 55px;
          margin: 0 auto;
        "
      >
        预设Flow流程，为您提高效率
      </div>
      <div
        style="
          width: 687px;
          color: #6a6a7e;
          text-align: center;
          font-family: PingFang SC;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 28px;
          margin: 0 auto;
          margin-top: 12px;
        "
      >
        自动化发送一封高效的邮件，往往比较困难，我们有超多场景下的流程模板，灵活调整、可定制任何流程。并且高效快捷的启用模板进行营销策略
      </div>

      <div
        style="
          width: 1024px;
          height: 1061px;
          display: flex;
          flex-wrap: wrap;
          gap: 64px 50px;
          margin: 0 auto;
          margin-top: 60px;
          margin-bottom: 132px;
        "
      >
        <div style="width: 308px">
          <img
            src="../assets/imgs/homeNew/flow-07.png"
            alt=""
            style="width: 308px; height: 354px"
          />
          <div
            style="
              width: 243px;
              display: flex;
              flex-direction: column;
              align-items: center;
              margin: 0 auto;
              margin-top: 32px;
            "
          >
            <div
              style="
                color: #292930;
                text-align: center;
                font-family: PingFang SC;
                font-size: 26px;
                font-style: normal;
                font-weight: 400;
                line-height: 110.5%;
              "
            >
              订阅欢迎
            </div>
            <div
              style="
                color: #6a6a7e;
                text-align: center;
                font-family: PingFang SC;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 27px;
                margin-top: 16px;
              "
            >
              新用户注册时，通过热情的邮件问候让用户留下电子邮件并转化为买家
            </div>
          </div>
        </div>

        <div style="width: 308px">
          <img
            src="../assets/imgs/homeNew/flow-08.png"
            alt=""
            style="width: 308px; height: 354px"
          />
          <div
            style="
              width: 243px;
              display: flex;
              flex-direction: column;
              align-items: center;
              margin: 0 auto;
              margin-top: 32px;
            "
          >
            <div
              style="
                color: #292930;
                text-align: center;
                font-family: PingFang SC;
                font-size: 26px;
                font-style: normal;
                font-weight: 400;
                line-height: 110.5%;
              "
            >
              弃浏召回
            </div>
            <div
              style="
                color: #6a6a7e;
                text-align: center;
                font-family: PingFang SC;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 27px;
                margin-top: 16px;
              "
            >
              当用户浏览了喜欢的东西没有下单，通过热情的邮件来挽回买家，促成下单
            </div>
          </div>
        </div>

        <div style="width: 308px">
          <img
            src="../assets/imgs/homeNew/flow-09.png"
            alt=""
            style="width: 308px; height: 354px"
          />
          <div
            style="
              width: 243px;
              display: flex;
              flex-direction: column;
              align-items: center;
              margin: 0 auto;
              margin-top: 32px;
            "
          >
            <div
              style="
                color: #292930;
                text-align: center;
                font-family: PingFang SC;
                font-size: 26px;
                font-style: normal;
                font-weight: 400;
                line-height: 110.5%;
              "
            >
              弃购召回
            </div>
            <div
              style="
                color: #6a6a7e;
                text-align: center;
                font-family: PingFang SC;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 27px;
                margin-top: 16px;
              "
            >
              用户把商品放进购物车且关闭页面时，通过热情的邮件来挽回买家，促成下单
            </div>
          </div>
        </div>

        <div style="width: 308px">
          <img
            src="../assets/imgs/homeNew/flow-10.png"
            alt=""
            style="width: 308px; height: 354px"
          />
          <div
            style="
              width: 243px;
              display: flex;
              flex-direction: column;
              align-items: center;
              margin: 0 auto;
              margin-top: 32px;
            "
          >
            <div
              style="
                color: #292930;
                text-align: center;
                font-family: PingFang SC;
                font-size: 26px;
                font-style: normal;
                font-weight: 400;
                line-height: 110.5%;
              "
            >
              弃单召回
            </div>
            <div
              style="
                color: #6a6a7e;
                text-align: center;
                font-family: PingFang SC;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 27px;
                margin-top: 16px;
              "
            >
              用户已经到了结账环节，但是迟迟没有支付下单，通过热情的邮件来挽回买家，促成下单
            </div>
          </div>
        </div>

        <div style="width: 308px">
          <img
            src="../assets/imgs/homeNew/flow-11.png"
            alt=""
            style="width: 308px; height: 354px"
          />
          <div
            style="
              width: 243px;
              display: flex;
              flex-direction: column;
              align-items: center;
              margin: 0 auto;
              margin-top: 32px;
            "
          >
            <div
              style="
                color: #292930;
                text-align: center;
                font-family: PingFang SC;
                font-size: 26px;
                font-style: normal;
                font-weight: 400;
                line-height: 110.5%;
              "
            >
              下单通知
            </div>
            <div
              style="
                color: #6a6a7e;
                text-align: center;
                font-family: PingFang SC;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 27px;
                margin-top: 16px;
              "
            >
              当用户下单成功后，下单通知流程可以自动把订单信息同步给客户。
            </div>
          </div>
        </div>

        <div style="width: 308px">
          <img
            src="../assets/imgs/homeNew/flow-12.png"
            alt=""
            style="width: 308px; height: 354px"
          />
          <div
            style="
              width: 243px;
              display: flex;
              flex-direction: column;
              align-items: center;
              margin: 0 auto;
              margin-top: 32px;
            "
          >
            <div
              style="
                color: #292930;
                text-align: center;
                font-family: PingFang SC;
                font-size: 26px;
                font-style: normal;
                font-weight: 400;
                line-height: 110.5%;
              "
            >
              下单邀评
            </div>
            <div
              style="
                color: #6a6a7e;
                text-align: center;
                font-family: PingFang SC;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 27px;
                margin-top: 16px;
              "
            >
              当用户下单成功后，下单通知流程可以自动把订单信息同步给客户。
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 收集弹窗 content 01 高提交率的弹窗模板-->
    <div style="width: 100%; height: 100%; background: #fff" v-if="bannerCheck === 'tanchuan'">
      <div
        style="
          margin: 0px auto 0px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 1170px;
          height: 707px;
        "
      >
        <div style="width: 434px; height: 301px">
          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
            "
          >
            // 01 . FLOW
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            高提交率的弹窗模板
          </div>

          <div
            style="
              width: 434px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            在用户信息收集中，因为弹窗提交率低困扰着您吗？我们提供一键配置的弹窗模板，巧妙引导用户填写邮箱，提高用户留资率，同时额外提升下单转化率，为您解决这一烦扰。
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              border: 1px solid #4e5363;
              background: #fff;
              width: 194px;
              height: 64px;
              color: #292930;
              font-family: PingFang SC;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              text-transform: capitalize;
              margin-top: 40px;
              cursor: pointer;
            "
            @click="login"
          >
            免费体验 CartSee
          </div>
        </div>
        <div style="width: 652px; height: 433px">
          <img
            src="../assets/imgs/homeNew/tanchuan-01.svg"
            alt=""
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </div>

    <!-- 收集弹窗 content 02 游戏化 — 大转盘 -->
    <div
      style="
        width: 100%;
        height: 100%;
        background: linear-gradient(289deg, #ecf2ff 35.35%, #ecfffa 131.65%), #ecf2ff;
      "
      v-if="bannerCheck === 'tanchuan'"
    >
      <div
        style="
          margin: 0px auto 0px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 1170px;
          height: 707px;
        "
      >
        <div style="width: 646px; height: 608px">
          <img
            src="../assets/imgs/homeNew/tanchuan-02.svg"
            alt=""
            style="width: 100%; height: 100%"
          />
        </div>

        <div style="width: 386px">
          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
            "
          >
            // 02 . Campaign
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            游戏化 — 大转盘
          </div>

          <div
            style="
              width: 386px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            一般用户看到无聊的弹窗，很有可能直接关闭，我们有大转盘形式的弹窗设计，以游戏化体验提高用户感受，降低垃圾弹窗疑虑，提升留资率，助力卖家高效运营。
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              border: 1px solid #fff;
              background: #fff;
              width: 194px;
              height: 64px;
              color: #292930;
              font-family: PingFang SC;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              text-transform: capitalize;
              margin-top: 40px;
              cursor: pointer;
            "
            @click="login"
          >
            免费体验 CartSee
          </div>
        </div>
      </div>
    </div>

    <!-- 收集弹窗 content 03 自定义收集信息-->
    <div style="width: 100%; height: 100%; background: #fff" v-if="bannerCheck === 'tanchuan'">
      <div
        style="
          margin: 0px auto 0px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 1170px;
          height: 707px;
        "
      >
        <div style="width: 433px; height: 301px">
          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
            "
          >
            // 03 . Campaign
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            自定义收集信息
          </div>

          <div
            style="
              width: 433px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            很多场景下，弹窗收集到的信息都很标准化，没有更多用途，你可以通过自定义弹窗收集用户信息，灵活选择所需数据，提高信息多样性，分类管理更高效，进一步优化转化率。
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              border: 1px solid #4e5363;
              background: #fff;
              width: 194px;
              height: 64px;
              color: #292930;
              font-family: PingFang SC;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              text-transform: capitalize;
              margin-top: 40px;
              cursor: pointer;
            "
            @click="login"
          >
            免费体验 CartSee
          </div>
        </div>
        <div style="width: 655px; height: 465px">
          <img
            src="../assets/imgs/homeNew/tanchuan-03.svg"
            alt=""
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </div>

    <!-- 收集弹窗 content 04 个性化信息分类 -->
    <div
      style="
        width: 100%;
        height: 100%;
        background: linear-gradient(289deg, #ecf2ff 35.35%, #ecfffa 131.65%), #ecf2ff;
        margin-bottom: 108px;
      "
      v-if="bannerCheck === 'tanchuan'"
    >
      <div
        style="
          margin: 0px auto 0px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 1170px;
          height: 707px;
        "
      >
        <div style="width: 670px; height: 540px">
          <img
            src="../assets/imgs/homeNew/tanchuan-04.svg"
            alt=""
            style="width: 100%; height: 100%"
          />
        </div>

        <div style="width: 405px">
          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
            "
          >
            // 04 . Campaign
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            个性化信息分类
          </div>

          <div
            style="
              width: 405px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            收集到的用户信息只是多了个客户而已？我们需要更加合理化的运营起来，将收集到的用户信息合理分类到用户群中，实现更个性化的邮件和短信营销，最大化提升收益。
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              border: 1px solid #fff;
              background: #fff;
              width: 194px;
              height: 64px;
              color: #292930;
              font-family: PingFang SC;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              text-transform: capitalize;
              margin-top: 40px;
              cursor: pointer;
            "
            @click="login"
          >
            免费体验 CartSee
          </div>
        </div>
      </div>
    </div>

    <!-- 用户细分 content 01 智能用户细分-->
    <div style="width: 100%; height: 100%; background: #fff" v-if="bannerCheck === 'user'">
      <div
        style="
          margin: 0px auto 0px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 1170px;
          height: 707px;
        "
      >
        <div style="width: 416px; height: 301px">
          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
            "
          >
            // 01 . Campaign
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            智能用户细分
          </div>

          <div
            style="
              width: 416px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            在发送邮件前，卖家务必明确用户的价值。您可以运营智能用户细分，自动进行用户分层：新用户、臻选活跃用户、回流潜在用户和可挖掘用户。帮助卖家明确触达用户。
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              border: 1px solid #4e5363;
              background: #fff;
              width: 194px;
              height: 64px;
              color: #292930;
              font-family: PingFang SC;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              text-transform: capitalize;
              margin-top: 40px;
              cursor: pointer;
            "
            @click="login"
          >
            免费体验 CartSee
          </div>
        </div>
        <div style="width: 620px; height: 506px">
          <img src="../assets/imgs/homeNew/user-01.svg" alt="" style="width: 100%; height: 100%" />
        </div>
      </div>
    </div>

    <!-- 用户细分 content 02  用户分层标签-->
    <div
      style="
        width: 100%;
        height: 100%;
        background: linear-gradient(289deg, #ecf2ff 35.35%, #ecfffa 131.65%), #ecf2ff;
        margin-bottom: 108px;
      "
      v-if="bannerCheck === 'user'"
    >
      <div
        style="
          margin: 0px auto 0px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 1170px;
          height: 707px;
        "
      >
        <div style="width: 585px; height: 488px">
          <img src="../assets/imgs/homeNew/user-02.svg" alt="" style="width: 100%; height: 100%" />
        </div>

        <div style="width: 386px">
          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
            "
          >
            // 02 . Campaign
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            用户分层标签
          </div>

          <div
            style="
              width: 386px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            通过用户标签查看基础信息、消费行为、兴趣爱好和网站行为等数据，帮助卖家发送更有针对性的邮件。
          </div>

          <div
            style="
              color: #292930;
              font-family: Noto Sans;
              font-size: 11.225px;
              font-style: normal;
              font-weight: 500;
              line-height: 156.5%;
              letter-spacing: 1.515px;
              text-transform: uppercase;
              margin-top: 40px;
            "
          >
            // 03 . Campaign
          </div>
          <div
            style="
              color: #292930;
              font-family: PingFang SC;
              font-size: 26px;
              font-style: normal;
              font-weight: 600;
              line-height: 110.5%;
              margin-top: 10px;
            "
          >
            商品匹配人群
          </div>

          <div
            style="
              width: 386px;
              color: #6a6a7e;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 28px;
              margin-top: 24px;
            "
          >
            怎么样让商品更好的找到对应的人群，可以通过实现商品与目标人群的精准匹配，通过产品定向配对策略，确保邮件高效送达，提升卖家转化
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              border: 1px solid #fff;
              background: #fff;
              width: 194px;
              height: 64px;
              color: #292930;
              font-family: PingFang SC;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              text-transform: capitalize;
              margin-top: 40px;
              cursor: pointer;
            "
            @click="login"
          >
            免费体验 CartSee
          </div>
        </div>
      </div>
    </div>

    <!-- 统一的底部 -->
    <!-- <div style="width: 100%; height: 124px">
      <img
        src="../assets/imgs/homeNew/footer-banner.png"
        alt=""
        style="width: 100%; height: 100%"
      />
    </div> -->

    <div
      style="
        width: 1170px;
        height: 448px;
        margin: 0px auto 0px;
        border-radius: 16px;
        background: #ecf2ff;
        display: flex;
        padding: 0px 0px 65px 65px;
        margin-bottom: 111px;
        position: relative;
        z-index: -1;
        padding: 80px 0px 86px 65px;
        margin-top: 16px;
      "
    >
      <div style="width: 576px;position: relative;height: 300px;">
        <div style="width: 36px; height: 18px;position: absolute;left: 76px;top: -21px;z-index: 1;">
          <img
            src="../assets/imgs/homeNew/Ellipse.svg"
            alt=""
            style="width: 100%;height: 100%;"
          />
        </div>

        <div
          style="
            color: #060640;
            font-family: PingFang SC;
            font-size: 30px;
            font-style: normal;
            font-weight: 500;
            line-height: 44px;
            width: 576px;
          "
        >
        更适合中国跨境电商卖家的营销自动化引擎
          <br />
          Cartsee为您带来更多营收
        </div>

        <div
          style="
            width: 576px;
            color: #9090a7;
            font-family: PingFang SC;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 28px;
            margin-top: 16px;
          "
        >
        不再盲目推送，而是精准触达。Cartsee 专注于服务中国卖家，提供效果最优的自动化营销解决方案，我们不仅仅提供适配中国卖家需求的营销平台，还提供服务大量中国卖家的过程中沉淀的宝贵经验和营销方法论，为卖家带来更高含金量的营收增长。
        </div>

        <div
          style="
            display: flex;
            height: 60px;
            width: 150px;
            justify-content: center;
            align-items: center;
            color: #fff;
            text-align: center;
            font-family: PingFang SC;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 15px;
            letter-spacing: 1.4px;
            border-radius: 6px;
            background: #060640;
            margin-top: 23px;
            cursor: pointer;
          "
          @click="login"
        >
          免费试用
        </div>

      </div>
      <div style="width: 624px; height: 624px;position: absolute;left: 650px;top: -98px;z-index: 1;">
        <img
          src="../assets/imgs/homeNew/footer-user.png"
          alt=""
          style="width: 100%; height: 100%"
        />
      </div>

    </div>

    <!-- 首页的footer 部分 黑色 -->
    <div
      style="width: 100%; height: 337px; background-color: #060640; padding-top: 80px"
      ref="footer"
    >
      <div
        style="
          width: 1141px;
          height: 210px;
          display: flex;
          justify-content: space-between;
          margin: 0px auto;
        "
      >
        <!-- 左边 -->
        <div style="width: 350px; height: 210px; margin-right: 150px">
          <div style="display: flex; width: 218px; height: 51px; align-items: center">
            <img
              src="../assets/imgs/homeNew/Vector2.svg"
              alt=""
              style="width: 43px; height: 51px"
            />
            <img
              src="../assets/imgs/homeNew/cartsee-logo2.svg"
              alt=""
              style="width: 157px; height: 35px"
            />
          </div>

          <div
            style="
              width: 350px;
              height: 60.149px;
              color: #9090a7;
              font-family: PingFang SC;
              font-size: 16px;
              font-style: normal;
              font-weight: 500;
              line-height: 28px;
              margin-top: 17px;
            "
          >
            选择更适合中国卖家的 Cartsee 意味着不费吹灰之力，即可提高你的营收
          </div>

          <div style="display: flex; margin-top: 17px">
            <el-popover
              placement="top"
              width="158px"
              trigger="click"
              popper-class="footer-tag-popper"
            >
              <div style="width: 146px; height: 200px">
                <img
                  src="../assets/imgs/homeNew/shipinghao-c.jpeg"
                  alt=""
                  style="width: 146px; height: 200px"
                />
              </div>
              <div
                style="width: 30px; height: 30px"
                slot="reference"
                @click="shipinghao('1')"
                @blur="isSmallIcon = ''"
              >
                <img
                  src="../assets/imgs/homeNew/shipinghao.svg"
                  alt=""
                  style="width: 30px; height: 30px"
                  v-if="isSmallIcon !== '1'"
                />
                <img
                  src="../assets/imgs/homeNew/shipinghao-l.svg"
                  alt=""
                  style="width: 30px; height: 30px"
                  v-if="isSmallIcon === '1'"
                />
              </div>
            </el-popover>
            <el-popover
              placement="top"
              width="158"
              trigger="click"
              popper-class="footer-tag-popper"
            >
              <div style="width: 146px; height: 183px">
                <img
                  src="../assets/imgs/homeNew/gongzhonghao.jpeg"
                  alt=""
                  style="width: 100%; height: 100%"
                />
              </div>
              <div
                style="width: 30px; height: 30px; margin-left: 16px"
                @click="shipinghao('2')"
                @blur="isSmallIcon = ''"
                slot="reference"
              >
                <img
                  src="../assets/imgs/homeNew/gongzhonghao.svg"
                  alt=""
                  style="width: 30px; height: 30px"
                  v-if="isSmallIcon !== '2'"
                />
                <img
                  src="../assets/imgs/homeNew/gongzhonghao-l.svg"
                  alt=""
                  style="width: 30px; height: 30px"
                  v-if="isSmallIcon === '2'"
                />
              </div>
            </el-popover>
            <el-popover
              placement="top"
              width="158"
              trigger="click"
              popper-class="footer-tag-popper"
            >
              <div style="width: 146px; height: 219px">
                <img
                  src="../assets/imgs/homeNew/douyin.jpeg"
                  alt=""
                  style="width: 100%; height: 100%"
                />
              </div>
              <div
                style="width: 30px; height: 30px; margin-left: 16px"
                @click="shipinghao('3')"
                @blur="isSmallIcon = ''"
                slot="reference"
              >
                <img
                  src="../assets/imgs/homeNew/douying.svg"
                  alt=""
                  style="width: 30px; height: 30px"
                  v-if="isSmallIcon !== '3'"
                />
                <img
                  src="../assets/imgs/homeNew/douying-l.svg"
                  alt=""
                  style="width: 30px; height: 30px"
                  v-if="isSmallIcon === '3'"
                />
              </div>
            </el-popover>
            <el-popover
              placement="top"
              width="158"
              trigger="click"
              popper-class="footer-tag-popper"
            >
              <div style="width: 146px; height: 183px">
                <img
                  src="../assets/imgs/homeNew/baijiahao.jpeg"
                  alt=""
                  style="width: 100%; height: 100%"
                />
              </div>
              <div
                style="width: 30px; height: 30px; margin-left: 16px"
                @click="shipinghao('4')"
                @blur="isSmallIcon = ''"
                slot="reference"
              >
                <img
                  src="../assets/imgs/homeNew/baijiahao.svg"
                  alt=""
                  style="width: 30px; height: 30px"
                  v-if="isSmallIcon !== '4'"
                />
                <img
                  src="../assets/imgs/homeNew/baijiahao-l.svg"
                  alt=""
                  style="width: 30px; height: 30px"
                  v-if="isSmallIcon === '4'"
                />
              </div>
            </el-popover>
          </div>
        </div>

        <div style="display: flex; justify-content: space-between; width: 100%">
          <div>
            <div
              style="
                color: #fff;
                font-family: PingFang SC;
                font-size: 18px;
                font-style: normal;
                font-weight: 400;
                line-height: 26px;
                width: 98px;
                height: 26px;
              "
            >
              快捷链接
            </div>
            <div style="margin-top: 20px">
              <div
                style="
                  color: #9090a7;
                  font-family: PingFang SC;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                  cursor: pointer;
                "
                @click="homeLink"
              >
                主页
              </div>
              <div
                style="
                  color: #9090a7;
                  font-family: PingFang SC;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                  margin-top: 12px;
                  cursor: pointer;
                "
                @click="productLink"
              >
                产品与服务
              </div>
              <div
                style="
                  color: #9090a7;
                  font-family: PingFang SC;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                  margin-top: 12px;
                  cursor: pointer;
                "
                @click="scrollToCustomerCase"
              >
                客户案例
              </div>
            </div>
          </div>
          <div>
            <div
              style="
                color: #fff;
                font-family: PingFang SC;
                font-size: 18px;
                font-style: normal;
                font-weight: 400;
                line-height: 26px;
                width: 98px;
                height: 26px;
              "
            >
              产品与服务
            </div>
            <div style="margin-top: 20px">
              <div
                style="
                  color: #9090a7;
                  font-family: PingFang SC;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                  cursor: pointer;
                "
                @click="campAbout"
              >
                营销活动
              </div>
              <div
                style="
                  color: #9090a7;
                  font-family: PingFang SC;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                  margin-top: 12px;
                  cursor: pointer;
                "
                @click="flowAbout"
              >
                营销流程
              </div>
              <div
                style="
                  color: #9090a7;
                  font-family: PingFang SC;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                  margin-top: 12px;
                  cursor: pointer;
                "
                @click="userAbout"
              >
                用户细分
              </div>

              <div
                style="
                  color: #9090a7;
                  font-family: PingFang SC;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                  margin-top: 12px;
                  cursor: pointer;
                "
                @click="tanchuanAbout"
              >
                收集弹窗
              </div>
            </div>
          </div>

          <div>
            <div
              style="
                color: #fff;
                font-family: PingFang SC;
                font-size: 18px;
                font-style: normal;
                font-weight: 400;
                line-height: 26px;
                width: 98px;
                height: 26px;
              "
            >
              更多信息
            </div>
            <div style="margin-top: 20px">
              <div
                style="
                  color: #9090a7;
                  font-family: PingFang SC;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                "
              >
                商务与合作
              </div>
              <div
                style="
                  color: #9090a7;
                  font-family: PingFang SC;
                  font-size: 12px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                  margin-top: 6px;
                "
              >
                contact@cartx.ai
              </div>
              <div
                style="
                  color: #9090a7;
                  font-family: PingFang SC;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                  margin-top: 31px;
                "
              >
                公司地址
              </div>
              <div
                style="
                  color: #9090a7;
                  font-family: PingFang SC;
                  font-size: 12px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                  margin-top: 4px;
                "
              >
              北京市海淀区优盛大厦 D 座 1802
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; height: 80px; background: #000020">
      <div
        style="
          width: 1170px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 0 auto;
          height: 80px;
        "
      >
        <div
          style="
            color: #9999A6;
            font-family: Open Sans;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 26px;
          "
        >
          Copyright © 2023 CartSee
        </div>
        <div style="
            font-family: Open Sans;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 26px;
            cursor: pointer;
          "
          @click="openbeian"
          class="beian"
          >
          京ICP备2023015904号-1
        </div>
        <div
          style="
            color: #9999A6;
            text-align: right;
            font-family: Open Sans;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 26px;
          "
        >
          All Rights Reserved
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="js">
import wx from "weixin-js-sdk";
import {getSing} from '../services/index';

export default {
  data() {
    return {
      // 标识 主页 产品与服务 客户案例 哪个被点击
      headerCheck: "home",
      // 表示点击了产品服务子级的哪个块
      bannerCheck: "",
      // 产品服务右边的按钮
      isRotated: false,
      // home页面的 智能用户分层 这几个选择器
      selectedOption: "1",
      isSmallIcon: '',
      underlinePosition: 0
    };
  },
  watch:{
    '$route'() {
        this.initHeaderCheck();
    }
  },
  methods: {
    // 点击了产品与服务 默认选中第一个campagin
    productClick() {
      this.isRotated = !this.isRotated;
      this.headerCheck = "product";
      // this.bannerCheck = '';
    },
    selectOption(option) {
      this.selectedOption = option;
      this.updateUnderlinePosition();
    },
    handleClick() {
      document.addEventListener('click', this.handleDocumentClick);
    },
    // 监听 当点击header 外面的时候 收起第二层
    handleDocumentClick(event) {
      const target = event.target;
      const firstLayer = this.$refs.firstLayer;
      const secondLayer = this.$refs.secondLayer;
      if ((firstLayer && !firstLayer.contains(target)) && (secondLayer && !secondLayer.contains(target))) {
        this.isRotated = false;
      }
    },
    scrollToCustomerCase() {
      if (this.headerCheck !== 'home') {
        this.headerCheck = "home";
        this.isRotated = false;
        // 使用 $nextTick 来确保在下一个 tick 中执行滚动操作
        this.$nextTick(() => {
          this.scrollToCustomerCase();
        });
      } else {
        // this.headerCheck = "home";
        this.isRotated = false;
        // 使用ref获取中间内容的DOM元素
        const customerCase = this.$refs.customerCase;

        // 滚动到中间内容的位置
        customerCase.scrollIntoView({ behavior: "smooth" });
      }
    },
    login() {
      window.open('https://app.cartsee.com/cartsee-new/login')
    },
    contactUs() {
      this.headerCheck = 'home';
      this.isRotated = false;
      const footer = this.$refs.footer;
      footer.scrollIntoView({behavior: "smooth"})
    },
    async goAbout(routerName, bannerCheck = '') {
      await this.goRouter(routerName, 'product', bannerCheck)
      await this.$nextTick();
      const header = this.$refs.header;
      header.scrollIntoView({behavior: "instant"})
    },
    // 主页campagin 的了解更多
    campAbout() {
      this.goAbout('Campaign', 'campagin')
    },
    flowAbout() {
      this.goAbout('Flow', 'flow')
    },
    tanchuanAbout() {
      this.goAbout('Tanchuan', 'tanchuan')
    },
    userAbout() {
      this.goAbout('User', 'user')
    },
    homeLink() {
      this.headerCheck = 'home';
      const header = this.$refs.header;
      header.scrollIntoView({behavior: "instant"})
    },
    productLink() {
      this.headerCheck = 'product';
      this.rotated = false;
      const header = this.$refs.header;
      header.scrollIntoView({behavior: "instant"})
    },
    shipinghao(index) {
      this.isSmallIcon = index;
    },
    closeSecondLayer() {
      this.isRotated = false;
    },
    updateUnderlinePosition() {
      if (this.selectedOption === '1') {
        this.underlinePosition = 0;
      } else if (this.selectedOption === '2') {
        this.underlinePosition = (Number(this.selectedOption) - 1) * 300; // Assuming each option has a width of 200px
      } else if (this.selectedOption === '3') {
        this.underlinePosition = (Number(this.selectedOption) - 1) * 300;
      } else if (this.selectedOption === '4') {
        this.underlinePosition = (Number(this.selectedOption) - 1) * 300;
      }
    },
    video() {
      window.open('https://www.douyin.com/video/7314873743199718671')
    },
    getShareInfo() {
      let res1;
      //获取url链接
      const url = window.location.href.split('#')[0]
      getSing(url).then(res => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
          appId: res.data.data.appId, // 必填，公众号的唯一标识
          timestamp: parseInt(res.data.data.timestamp), // 必填，生成签名的时间戳
          nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.data.signature, // 必填，签名
          jsApiList: [
            "updateAppMessageShareData",
            "updateTimelineShareData"
          ] // 必填，需要使用的 JS 接口列表
        });
        wx.ready(() => {
          const shareData = {
            title: "更适合中国海外卖家的营销自动化引擎",
            desc: "选择更适合中国卖家的Cartsee 意味着不费吹灰之力，即可提高你的营收",
            // link: window.location.href,
            link: window.location.href.split('#')[0],
            imgUrl: "https://image.cartx.cloud/cartsee-website/20240117-180705.jpeg",
          };
          //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
          wx.updateAppMessageShareData(shareData);
          //自定义“分享到朋友圈”及“分享到 QQ 空间”按钮的分享内容（1.4.0）
          wx.updateTimelineShareData(shareData);
        });
        //错误了会走 这里
        wx.error(function (res) {
          res1 = res;
        });
      });
    },
    async goRouter(routerName, headerCheck = '', bannerCheck = '') {
      await this.$router.push({
        name: routerName,
        query:{
          headerCheck,
          bannerCheck
        }
      })
      this.initHeaderCheck();
    },
    initHeaderCheck() {
      this.headerCheck = this.$route.query.headerCheck || 'home';
      this.bannerCheck = this.$route.query.bannerCheck || '';
    },
    openbeian() {
      window.open('https://beian.miit.gov.cn/')
    }
  },
  created() {
    // 调用微信分型的事件
    this.getShareInfo();
    this.initHeaderCheck();
  },
  mounted() {
    this.handleClick();
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick);
  },
};
</script>
<style lang="scss">
.rotated {
  transform: rotate(180deg);
  transition: transform 0.3s ease; /* 可选：添加过渡效果 */
}
.container {
  // position: relative;
  background: linear-gradient(229deg, #ecf2ff 38.22%, #ecfffa 109.58%);
  // background-size: 1170px 640px;
  // z-index: 10000;
}
.footer-tag-popper {
  padding: 6px !important;
}
.dropdown-enter-active, .dropdown-leave-active {
  transition: opacity 0.3s;
}
.dropdown-enter, .dropdown-leave-to {
  opacity: 0;
}
// .fade-enter-active, .fade-leave-active {
//   transition: all .3s ease;
// }
// .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
//   opacity: 0;
// }
.fade-enter-active {
  transition: all .3s ease;
}
.fade-leave-active {
  transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fade-enter, .fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.underline {
  transition: transform 0.3s;
}
.fade1-enter-active, .fade-leave-active {
  transition: opacity 0.8s;
}
.fade1-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.fade2-enter-active, .fade2-leave-active {
  transition: opacity .01s;
}
.fade2-enter, .fade2-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.beian {
  color: #9999A6;
}
.beian:hover {
  color: #fff;
}
</style>
